import { InvalidCredentialsError, InvalidInputError } from '@/lib/error-type';
import { fetcher } from '@/lib/fetcher';
import {
  InfiniteData,
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
  useSuspenseInfiniteQuery,
  UseSuspenseInfiniteQueryOptions,
  useSuspenseQuery,
  UseSuspenseQueryOptions,
} from '@tanstack/react-query';
import { ClientError } from 'graphql-request';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  bigint: { input: any; output: any };
  date: { input: string; output: string };
  float8: { input: number; output: number };
  geography: { input: object; output: object };
  geometry: { input: object; output: object };
  json: { input: any; output: any };
  jsonb: { input: object; output: object };
  timestamp: { input: string; output: string };
  timestamptz: { input: string; output: string };
  uuid: { input: string; output: string };
};

export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Mutation = {
  bamboo_redemption_transaction: Graphql_Transaction;
  bamboo_send_receipt_email: Scalars['String']['output'];
  bamboo_sms_send_receipt: Scalars['String']['output'];
  bamboo_top_up_transaction: Graphql_Bamboo_Transaction;
  create_import_gift_card_request: Graphql_Generate_Gift_Card_Request;
  crm_export_gift_card_report: Graphql_Export_Gift_Card;
  crm_generate_login_url: Scalars['String']['output'];
  crm_reset_gift_card: Graphql_Gift_Card;
  crm_update_gift_card: Graphql_Gift_Card;
  customer_create_customer: Customer_Posted;
  dts_create_gift_card: Graphql_Create_Gift_Card_Dts;
  dts_create_multiple_transaction: Scalars['String']['output'];
  dts_create_transaction: Graphql_Transaction;
  dts_generate_login_url: Graphql_User_Login_Url;
  dts_import_gift_card: Graphql_Gift_Card;
  dts_reset_custom_field_gift_card: Gql_Transaction;
  dts_reset_custom_field_transaction: Gql_Transaction;
  dts_revert_transaction: Graphql_Transaction;
  dts_update_gift_card: Graphql_Gift_Card;
  gci_business_create_transaction: Graphql_Transaction;
  gci_business_reset_custom_field_gift_card: Graphql_Gift_Card;
  gci_business_reset_custom_field_transaction: Gql_Transaction;
  gift_card_create_generate_gift_card_request: Graphql_Generate_Gift_Card_Request;
  gift_card_create_prefix_gift_card_code: Gql_Prefix_Code_Posted;
  valor_create_transaction: Graphql_Transaction;
};

export type MutationBamboo_Redemption_TransactionArgs = {
  input_obj: Bamboo_Redemption_Transaction_Input;
};

export type MutationBamboo_Send_Receipt_EmailArgs = {
  input_obj: Bamboo_Send_Receipt_Email_Input;
};

export type MutationBamboo_Sms_Send_ReceiptArgs = {
  input_obj: Bamboo_Sms_Send_Receipt_Input;
};

export type MutationBamboo_Top_Up_TransactionArgs = {
  input_obj: Bamboo_Top_Up_Transaction_Input;
};

export type MutationCreate_Import_Gift_Card_RequestArgs = {
  input_obj: Create_Import_Gift_Card_Request_Input;
};

export type MutationCrm_Export_Gift_Card_ReportArgs = {
  input_obj: Crm_Export_Gift_Card_Report_Input;
};

export type MutationCrm_Generate_Login_UrlArgs = {
  input_obj: Crm_Generate_Login_Url_Input;
};

export type MutationCrm_Reset_Gift_CardArgs = {
  input_obj: Crm_Reset_Gift_Card_Input;
};

export type MutationCrm_Update_Gift_CardArgs = {
  input_obj: Crm_Update_Gift_Card_Input;
};

export type MutationCustomer_Create_CustomerArgs = {
  input_obj: Customer_Create_Customer_Input;
};

export type MutationDts_Create_Gift_CardArgs = {
  input_obj: Dts_Create_Gift_Card_Input;
};

export type MutationDts_Create_Multiple_TransactionArgs = {
  input_obj: Dts_Create_Multiple_Transaction_Input;
};

export type MutationDts_Create_TransactionArgs = {
  input_obj: Dts_Create_Transaction_Input;
};

export type MutationDts_Generate_Login_UrlArgs = {
  input_obj: Dts_Generate_Login_Url_Input;
};

export type MutationDts_Import_Gift_CardArgs = {
  input_obj: Dts_Import_Gift_Card_Input;
};

export type MutationDts_Reset_Custom_Field_Gift_CardArgs = {
  input_obj: Dts_Reset_Custom_Field_Gift_Card_Input;
};

export type MutationDts_Reset_Custom_Field_TransactionArgs = {
  input_obj: Dts_Reset_Custom_Field_Transaction_Input;
};

export type MutationDts_Revert_TransactionArgs = {
  input_obj: Dts_Revert_Transaction_Input;
};

export type MutationDts_Update_Gift_CardArgs = {
  input_obj: Dts_Update_Gift_Card_Input;
};

export type MutationGci_Business_Create_TransactionArgs = {
  input_obj: Gci_Business_Create_Transaction_Input;
};

export type MutationGci_Business_Reset_Custom_Field_Gift_CardArgs = {
  input_obj: Gci_Business_Reset_Custom_Field_Gift_Card_Input;
};

export type MutationGci_Business_Reset_Custom_Field_TransactionArgs = {
  input_obj: Gci_Business_Reset_Custom_Field_Transaction_Input;
};

export type MutationGift_Card_Create_Generate_Gift_Card_RequestArgs = {
  input_obj: Gift_Card_Create_Generate_Gift_Card_Request_Input;
};

export type MutationGift_Card_Create_Prefix_Gift_Card_CodeArgs = {
  input_obj: Gift_Card_Create_Prefix_Gift_Card_Code_Input;
};

export type MutationValor_Create_TransactionArgs = {
  input_obj: Valor_Create_Transaction_Input;
};

export type Query = {
  _dummy: Scalars['String']['output'];
  bamboo_user_get_info?: Maybe<Graphql_Bamboo_User>;
  card_info: Array<Card_Info>;
  card_info_aggregate: Card_Info_Aggregate;
  card_info_by_pk?: Maybe<Card_Info>;
  crm_action_log: Array<Crm_Action_Log>;
  crm_action_log_aggregate: Crm_Action_Log_Aggregate;
  crm_action_log_by_pk?: Maybe<Crm_Action_Log>;
  crm_client_company: Array<Crm_Client_Company>;
  crm_client_company_by_pk?: Maybe<Crm_Client_Company>;
  crm_client_contact: Array<Crm_Client_Contact>;
  crm_company?: Maybe<Graphql_Crm_Company>;
  crm_fin_invoice: Array<Crm_Fin_Invoice>;
  crm_user: Array<Crm_User>;
  customer: Array<Customer>;
  customer_aggregate: Customer_Aggregate;
  customer_by_pk?: Maybe<Customer>;
  customer_company: Array<Customer_Company>;
  customer_company_aggregate: Customer_Company_Aggregate;
  customer_company_by_pk?: Maybe<Customer_Company>;
  export_gift_card_report_request: Array<Export_Gift_Card_Report_Request>;
  export_gift_card_report_request_aggregate: Export_Gift_Card_Report_Request_Aggregate;
  export_gift_card_report_request_by_pk?: Maybe<Export_Gift_Card_Report_Request>;
  get_transaction_detail: Graphql_Get_Transaction_Detail;
  gift_card: Array<Gift_Card>;
  gift_card_aggregate: Gift_Card_Aggregate;
  gift_card_by_pk?: Maybe<Gift_Card>;
  gift_card_check_code?: Maybe<Graphql_Gift_Card_Check_Code>;
  gift_card_prefix_code: Array<Gift_Card_Prefix_Code>;
  gift_card_prefix_code_aggregate: Gift_Card_Prefix_Code_Aggregate;
  gift_card_prefix_code_by_pk?: Maybe<Gift_Card_Prefix_Code>;
  import_gift_card_request: Array<Import_Gift_Card_Request>;
  import_gift_card_request_aggregate: Import_Gift_Card_Request_Aggregate;
  import_gift_card_request_by_pk?: Maybe<Import_Gift_Card_Request>;
  payment_method: Array<Payment_Method>;
  payment_method_aggregate: Payment_Method_Aggregate;
  payment_method_by_pk?: Maybe<Payment_Method>;
  pos_gift_card: Array<Pos_Gift_Card>;
  pos_gift_card_aggregate: Pos_Gift_Card_Aggregate;
  pos_gift_card_by_pk?: Maybe<Pos_Gift_Card>;
  storage_object: Array<Storage_Object>;
  storage_object_aggregate: Storage_Object_Aggregate;
  storage_object_by_pk?: Maybe<Storage_Object>;
  transaction: Array<Transaction>;
  transaction_aggregate: Transaction_Aggregate;
  transaction_by_pk?: Maybe<Transaction>;
  transaction_discount: Array<Transaction_Discount>;
  transaction_discount_aggregate: Transaction_Discount_Aggregate;
  transaction_discount_by_pk?: Maybe<Transaction_Discount>;
  user_get_info?: Maybe<Graphql_User>;
};

export type QueryCard_InfoArgs = {
  distinct_on?: InputMaybe<Array<Card_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Card_Info_Order_By>>;
  where?: InputMaybe<Card_Info_Bool_Exp>;
};

export type QueryCard_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Card_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Card_Info_Order_By>>;
  where?: InputMaybe<Card_Info_Bool_Exp>;
};

export type QueryCard_Info_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryCrm_Action_LogArgs = {
  distinct_on?: InputMaybe<Array<Crm_Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Action_Log_Order_By>>;
  where?: InputMaybe<Crm_Action_Log_Bool_Exp>;
};

export type QueryCrm_Action_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Action_Log_Order_By>>;
  where?: InputMaybe<Crm_Action_Log_Bool_Exp>;
};

export type QueryCrm_Action_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryCrm_Client_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Crm_Client_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Client_Company_Order_By>>;
  where?: InputMaybe<Crm_Client_Company_Bool_Exp>;
};

export type QueryCrm_Client_Company_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryCrm_Client_ContactArgs = {
  distinct_on?: InputMaybe<Array<Crm_Client_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Client_Contact_Order_By>>;
  where?: InputMaybe<Crm_Client_Contact_Bool_Exp>;
};

export type QueryCrm_CompanyArgs = {
  input_obj: Crm_Company_Input;
};

export type QueryCrm_Fin_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type QueryCrm_UserArgs = {
  distinct_on?: InputMaybe<Array<Crm_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_User_Order_By>>;
  where?: InputMaybe<Crm_User_Bool_Exp>;
};

export type QueryCustomerArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};

export type QueryCustomer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};

export type QueryCustomer_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryCustomer_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Customer_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Company_Order_By>>;
  where?: InputMaybe<Customer_Company_Bool_Exp>;
};

export type QueryCustomer_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Company_Order_By>>;
  where?: InputMaybe<Customer_Company_Bool_Exp>;
};

export type QueryCustomer_Company_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryExport_Gift_Card_Report_RequestArgs = {
  distinct_on?: InputMaybe<
    Array<Export_Gift_Card_Report_Request_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Gift_Card_Report_Request_Order_By>>;
  where?: InputMaybe<Export_Gift_Card_Report_Request_Bool_Exp>;
};

export type QueryExport_Gift_Card_Report_Request_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Export_Gift_Card_Report_Request_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Export_Gift_Card_Report_Request_Order_By>>;
  where?: InputMaybe<Export_Gift_Card_Report_Request_Bool_Exp>;
};

export type QueryExport_Gift_Card_Report_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryGet_Transaction_DetailArgs = {
  input_obj: Get_Transaction_Detail_Input;
};

export type QueryGift_CardArgs = {
  distinct_on?: InputMaybe<Array<Gift_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gift_Card_Order_By>>;
  where?: InputMaybe<Gift_Card_Bool_Exp>;
};

export type QueryGift_Card_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gift_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gift_Card_Order_By>>;
  where?: InputMaybe<Gift_Card_Bool_Exp>;
};

export type QueryGift_Card_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryGift_Card_Check_CodeArgs = {
  input_obj: Gift_Card_Check_Code_Input;
};

export type QueryGift_Card_Prefix_CodeArgs = {
  distinct_on?: InputMaybe<Array<Gift_Card_Prefix_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gift_Card_Prefix_Code_Order_By>>;
  where?: InputMaybe<Gift_Card_Prefix_Code_Bool_Exp>;
};

export type QueryGift_Card_Prefix_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gift_Card_Prefix_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gift_Card_Prefix_Code_Order_By>>;
  where?: InputMaybe<Gift_Card_Prefix_Code_Bool_Exp>;
};

export type QueryGift_Card_Prefix_Code_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryImport_Gift_Card_RequestArgs = {
  distinct_on?: InputMaybe<Array<Import_Gift_Card_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Import_Gift_Card_Request_Order_By>>;
  where?: InputMaybe<Import_Gift_Card_Request_Bool_Exp>;
};

export type QueryImport_Gift_Card_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_Gift_Card_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Import_Gift_Card_Request_Order_By>>;
  where?: InputMaybe<Import_Gift_Card_Request_Bool_Exp>;
};

export type QueryImport_Gift_Card_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryPayment_MethodArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};

export type QueryPayment_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};

export type QueryPayment_Method_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryPos_Gift_CardArgs = {
  distinct_on?: InputMaybe<Array<Pos_Gift_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pos_Gift_Card_Order_By>>;
  where?: InputMaybe<Pos_Gift_Card_Bool_Exp>;
};

export type QueryPos_Gift_Card_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pos_Gift_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pos_Gift_Card_Order_By>>;
  where?: InputMaybe<Pos_Gift_Card_Bool_Exp>;
};

export type QueryPos_Gift_Card_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryStorage_ObjectArgs = {
  distinct_on?: InputMaybe<Array<Storage_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storage_Object_Order_By>>;
  where?: InputMaybe<Storage_Object_Bool_Exp>;
};

export type QueryStorage_Object_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Object_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Storage_Object_Order_By>>;
  where?: InputMaybe<Storage_Object_Bool_Exp>;
};

export type QueryStorage_Object_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryTransactionArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

export type QueryTransaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

export type QueryTransaction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type QueryTransaction_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Discount_Order_By>>;
  where?: InputMaybe<Transaction_Discount_Bool_Exp>;
};

export type QueryTransaction_Discount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Discount_Order_By>>;
  where?: InputMaybe<Transaction_Discount_Bool_Exp>;
};

export type QueryTransaction_Discount_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  _niregex?: InputMaybe<Scalars['String']['input']>;
  _nlike?: InputMaybe<Scalars['String']['input']>;
  _nregex?: InputMaybe<Scalars['String']['input']>;
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  _regex?: InputMaybe<Scalars['String']['input']>;
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type Bamboo_Card_Info_Input = {
  card_expiration_date?: InputMaybe<Scalars['String']['input']>;
  card_first_six?: InputMaybe<Scalars['String']['input']>;
  card_holder_name?: InputMaybe<Scalars['String']['input']>;
  card_last_four?: InputMaybe<Scalars['String']['input']>;
  card_type?: InputMaybe<Scalars['String']['input']>;
  card_zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type Bamboo_Charge_Input = {
  action: Scalars['String']['input'];
  arqc: Scalars['String']['input'];
  data_dfdf56: Scalars['String']['input'];
  data_dfdf57: Scalars['String']['input'];
  device_sn: Scalars['String']['input'];
};

export type Bamboo_Manual_Card_Input = {
  token: Scalars['String']['input'];
};

export type Bamboo_Payment_Input = {
  card_info?: InputMaybe<Bamboo_Card_Info_Input>;
  charge_info?: InputMaybe<Bamboo_Charge_Input>;
  manual_card_info?: InputMaybe<Bamboo_Manual_Card_Input>;
  payment_method: Scalars['String']['input'];
  price: Scalars['String']['input'];
};

export type Bamboo_Redemption_Transaction_Input = {
  balance_change: Scalars['Int']['input'];
  date: Scalars['String']['input'];
  description: Scalars['String']['input'];
  gift_card_id: Scalars['uuid']['input'];
  whmcs_id: Scalars['Int']['input'];
};

export type Bamboo_Send_Receipt_Email_Input = {
  receiver_email: Scalars['String']['input'];
  transaction_id: Scalars['uuid']['input'];
};

export type Bamboo_Sms_Send_Receipt_Input = {
  receiver_phone_number: Scalars['String']['input'];
  transaction_id: Scalars['uuid']['input'];
};

export type Bamboo_Top_Up_Transaction_Input = {
  balance_change: Scalars['Int']['input'];
  date: Scalars['String']['input'];
  description: Scalars['String']['input'];
  discount_percent_value: Scalars['Int']['input'];
  gift_card_id: Scalars['uuid']['input'];
  payments: Array<Bamboo_Payment_Input>;
  whmcs_id: Scalars['Int']['input'];
};

export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

export type Card_Info = {
  card_number_first_six?: Maybe<Scalars['String']['output']>;
  card_number_last_four?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  card_zip_code?: Maybe<Scalars['String']['output']>;
  cardholder_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  entry_type?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  payment_methods: Array<Payment_Method>;
  payment_methods_aggregate: Payment_Method_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};

export type Card_InfoPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};

export type Card_InfoPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};

export type Card_Info_Aggregate = {
  aggregate?: Maybe<Card_Info_Aggregate_Fields>;
  nodes: Array<Card_Info>;
};

export type Card_Info_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Card_Info_Max_Fields>;
  min?: Maybe<Card_Info_Min_Fields>;
};

export type Card_Info_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Card_Info_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Card_Info_Bool_Exp = {
  _and?: InputMaybe<Array<Card_Info_Bool_Exp>>;
  _not?: InputMaybe<Card_Info_Bool_Exp>;
  _or?: InputMaybe<Array<Card_Info_Bool_Exp>>;
  card_number_first_six?: InputMaybe<String_Comparison_Exp>;
  card_number_last_four?: InputMaybe<String_Comparison_Exp>;
  card_type?: InputMaybe<String_Comparison_Exp>;
  card_zip_code?: InputMaybe<String_Comparison_Exp>;
  cardholder_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entry_type?: InputMaybe<String_Comparison_Exp>;
  expiration_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_methods?: InputMaybe<Payment_Method_Bool_Exp>;
  payment_methods_aggregate?: InputMaybe<Payment_Method_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

export type Card_Info_Max_Fields = {
  card_number_first_six?: Maybe<Scalars['String']['output']>;
  card_number_last_four?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  card_zip_code?: Maybe<Scalars['String']['output']>;
  cardholder_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entry_type?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

export type Card_Info_Min_Fields = {
  card_number_first_six?: Maybe<Scalars['String']['output']>;
  card_number_last_four?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  card_zip_code?: Maybe<Scalars['String']['output']>;
  cardholder_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entry_type?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

export type Card_Info_Order_By = {
  card_number_first_six?: InputMaybe<Order_By>;
  card_number_last_four?: InputMaybe<Order_By>;
  card_type?: InputMaybe<Order_By>;
  card_zip_code?: InputMaybe<Order_By>;
  cardholder_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_type?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_methods_aggregate?: InputMaybe<Payment_Method_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

export enum Card_Info_Select_Column {
  CardNumberFirstSix = 'card_number_first_six',
  CardNumberLastFour = 'card_number_last_four',
  CardType = 'card_type',
  CardZipCode = 'card_zip_code',
  CardholderName = 'cardholder_name',
  CreatedAt = 'created_at',
  EntryType = 'entry_type',
  ExpirationDate = 'expiration_date',
  Id = 'id',
  UpdatedAt = 'updated_at',
}

export type Create_Import_Gift_Card_Request_Input = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  num_of_gift_card: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  whmcs_id: Scalars['Int']['input'];
  zipCode: Scalars['String']['input'];
};

export type Crm_Action_Log = {
  after_value: Scalars['jsonb']['output'];
  before_value?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  crm_user: Array<Crm_User>;
  gift_card?: Maybe<Gift_Card>;
  id: Scalars['uuid']['output'];
  obj_action: Scalars['String']['output'];
  obj_id: Scalars['uuid']['output'];
  obj_type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
};

export type Crm_Action_LogAfter_ValueArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Action_LogBefore_ValueArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Action_Log_Aggregate = {
  aggregate?: Maybe<Crm_Action_Log_Aggregate_Fields>;
  nodes: Array<Crm_Action_Log>;
};

export type Crm_Action_Log_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Crm_Action_Log_Max_Fields>;
  min?: Maybe<Crm_Action_Log_Min_Fields>;
};

export type Crm_Action_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crm_Action_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Crm_Action_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Action_Log_Bool_Exp>>;
  _not?: InputMaybe<Crm_Action_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Action_Log_Bool_Exp>>;
  after_value?: InputMaybe<Jsonb_Comparison_Exp>;
  before_value?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gift_card?: InputMaybe<Gift_Card_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  obj_action?: InputMaybe<String_Comparison_Exp>;
  obj_id?: InputMaybe<Uuid_Comparison_Exp>;
  obj_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

export type Crm_Action_Log_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  obj_action?: Maybe<Scalars['String']['output']>;
  obj_id?: Maybe<Scalars['uuid']['output']>;
  obj_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

export type Crm_Action_Log_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  obj_action?: Maybe<Scalars['String']['output']>;
  obj_id?: Maybe<Scalars['uuid']['output']>;
  obj_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

export type Crm_Action_Log_Order_By = {
  after_value?: InputMaybe<Order_By>;
  before_value?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gift_card?: InputMaybe<Gift_Card_Order_By>;
  id?: InputMaybe<Order_By>;
  obj_action?: InputMaybe<Order_By>;
  obj_id?: InputMaybe<Order_By>;
  obj_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

export enum Crm_Action_Log_Select_Column {
  AfterValue = 'after_value',
  BeforeValue = 'before_value',
  CreatedAt = 'created_at',
  Id = 'id',
  ObjAction = 'obj_action',
  ObjId = 'obj_id',
  ObjType = 'obj_type',
  UpdatedAt = 'updated_at',
  UserId = 'user_id',
}

export type Crm_Client_Company = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  addressUpdatedByUser?: Maybe<Crm_User>;
  avatar_url?: Maybe<Scalars['String']['output']>;
  booking_url?: Maybe<Scalars['String']['output']>;
  business_logo?: Maybe<Scalars['String']['output']>;
  business_phone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  client_contact_companies: Array<Crm_Client_Contact_Company>;
  country?: Maybe<Scalars['String']['output']>;
  cover_url?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  fin_invoices: Array<Crm_Fin_Invoice>;
  fin_invoices_aggregate: Crm_Fin_Invoice_Aggregate;
  gallery_urls?: Maybe<Scalars['jsonb']['output']>;
  geometry?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['uuid']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longtitude?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamp']['output'];
  whmcs_id: Scalars['Int']['output'];
};

export type Crm_Client_CompanyClient_Contact_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Crm_Client_Contact_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Client_Contact_Company_Order_By>>;
  where?: InputMaybe<Crm_Client_Contact_Company_Bool_Exp>;
};

export type Crm_Client_CompanyFin_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_Client_CompanyFin_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_Client_CompanyGallery_UrlsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Client_Company_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Client_Company_Bool_Exp>>;
  _not?: InputMaybe<Crm_Client_Company_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Client_Company_Bool_Exp>>;
  address1?: InputMaybe<String_Comparison_Exp>;
  address2?: InputMaybe<String_Comparison_Exp>;
  addressUpdatedByUser?: InputMaybe<Crm_User_Bool_Exp>;
  avatar_url?: InputMaybe<String_Comparison_Exp>;
  booking_url?: InputMaybe<String_Comparison_Exp>;
  business_logo?: InputMaybe<String_Comparison_Exp>;
  business_phone?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  client_contact_companies?: InputMaybe<Crm_Client_Contact_Company_Bool_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  cover_url?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  fin_invoices?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  fin_invoices_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp>;
  gallery_urls?: InputMaybe<Jsonb_Comparison_Exp>;
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latitude?: InputMaybe<String_Comparison_Exp>;
  longtitude?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  postal_code?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  whmcs_id?: InputMaybe<Int_Comparison_Exp>;
};

export type Crm_Client_Company_Order_By = {
  address1?: InputMaybe<Order_By>;
  address2?: InputMaybe<Order_By>;
  addressUpdatedByUser?: InputMaybe<Crm_User_Order_By>;
  avatar_url?: InputMaybe<Order_By>;
  booking_url?: InputMaybe<Order_By>;
  business_logo?: InputMaybe<Order_By>;
  business_phone?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  client_contact_companies_aggregate?: InputMaybe<Crm_Client_Contact_Company_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  cover_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fin_invoices_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Order_By>;
  gallery_urls?: InputMaybe<Order_By>;
  geometry?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longtitude?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export enum Crm_Client_Company_Select_Column {
  Address1 = 'address1',
  Address2 = 'address2',
  AvatarUrl = 'avatar_url',
  BookingUrl = 'booking_url',
  BusinessLogo = 'business_logo',
  BusinessPhone = 'business_phone',
  City = 'city',
  Country = 'country',
  CoverUrl = 'cover_url',
  CreatedAt = 'created_at',
  GalleryUrls = 'gallery_urls',
  Geometry = 'geometry',
  Id = 'id',
  Latitude = 'latitude',
  Longtitude = 'longtitude',
  Name = 'name',
  Note = 'note',
  PostalCode = 'postal_code',
  State = 'state',
  Status = 'status',
  UpdatedAt = 'updated_at',
  WhmcsId = 'whmcs_id',
}

export type Crm_Client_Contact = {
  client_contact_companies: Array<Crm_Client_Contact_Company>;
  created_at: Scalars['timestamp']['output'];
  creator_id?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Crm_User>;
  updated_at: Scalars['timestamp']['output'];
  updator_id?: Maybe<Scalars['uuid']['output']>;
};

export type Crm_Client_ContactClient_Contact_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Crm_Client_Contact_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Client_Contact_Company_Order_By>>;
  where?: InputMaybe<Crm_Client_Contact_Company_Bool_Exp>;
};

export type Crm_Client_Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Client_Contact_Bool_Exp>>;
  _not?: InputMaybe<Crm_Client_Contact_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Client_Contact_Bool_Exp>>;
  client_contact_companies?: InputMaybe<Crm_Client_Contact_Company_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  updatedBy?: InputMaybe<Crm_User_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updator_id?: InputMaybe<Uuid_Comparison_Exp>;
};

export type Crm_Client_Contact_Company = {
  client_company: Crm_Client_Company;
  client_contact: Crm_Client_Contact;
  company_id: Scalars['uuid']['output'];
  contact_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamp']['output'];
  creator_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  role: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedBy?: Maybe<Crm_User>;
  updated_at: Scalars['timestamp']['output'];
  updator_id?: Maybe<Scalars['uuid']['output']>;
};

export type Crm_Client_Contact_Company_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crm_Client_Contact_Company_Max_Order_By>;
  min?: InputMaybe<Crm_Client_Contact_Company_Min_Order_By>;
};

export type Crm_Client_Contact_Company_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Client_Contact_Company_Bool_Exp>>;
  _not?: InputMaybe<Crm_Client_Contact_Company_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Client_Contact_Company_Bool_Exp>>;
  client_company?: InputMaybe<Crm_Client_Company_Bool_Exp>;
  client_contact?: InputMaybe<Crm_Client_Contact_Bool_Exp>;
  company_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updatedBy?: InputMaybe<Crm_User_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updator_id?: InputMaybe<Uuid_Comparison_Exp>;
};

export type Crm_Client_Contact_Company_Max_Order_By = {
  company_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updator_id?: InputMaybe<Order_By>;
};

export type Crm_Client_Contact_Company_Min_Order_By = {
  company_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updator_id?: InputMaybe<Order_By>;
};

export type Crm_Client_Contact_Company_Order_By = {
  client_company?: InputMaybe<Crm_Client_Company_Order_By>;
  client_contact?: InputMaybe<Crm_Client_Contact_Order_By>;
  company_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Crm_User_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updator_id?: InputMaybe<Order_By>;
};

export enum Crm_Client_Contact_Company_Select_Column {
  CompanyId = 'company_id',
  ContactId = 'contact_id',
  CreatedAt = 'created_at',
  CreatorId = 'creator_id',
  Id = 'id',
  Role = 'role',
  Status = 'status',
  UpdatedAt = 'updated_at',
  UpdatorId = 'updator_id',
}

export type Crm_Client_Contact_Order_By = {
  client_contact_companies_aggregate?: InputMaybe<Crm_Client_Contact_Company_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Crm_User_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updator_id?: InputMaybe<Order_By>;
};

export enum Crm_Client_Contact_Select_Column {
  CreatedAt = 'created_at',
  CreatorId = 'creator_id',
  Email = 'email',
  Id = 'id',
  Name = 'name',
  Phone = 'phone',
  UpdatedAt = 'updated_at',
  UpdatorId = 'updator_id',
}

export type Crm_Company_Input = {
  whmcs_id: Scalars['Int']['input'];
};

export type Crm_Export_Gift_Card_Report_Input = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  whmcs_id: Scalars['Int']['input'];
};

export type Crm_Fin_Invoice = {
  allow_no_sign?: Maybe<Scalars['Boolean']['output']>;
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  balance?: Maybe<Scalars['float8']['output']>;
  begin_date?: Maybe<Scalars['date']['output']>;
  canceled_reason?: Maybe<Scalars['String']['output']>;
  client_company?: Maybe<Crm_Client_Company>;
  client_company_id?: Maybe<Scalars['uuid']['output']>;
  client_contact?: Maybe<Crm_Client_Contact>;
  client_contact_id?: Maybe<Scalars['uuid']['output']>;
  client_contact_info?: Maybe<Scalars['jsonb']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  contextual?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  created_by_id?: Maybe<Scalars['uuid']['output']>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  credit?: Maybe<Scalars['float8']['output']>;
  credit_use?: Maybe<Scalars['float8']['output']>;
  date: Scalars['timestamp']['output'];
  date_paid?: Maybe<Scalars['timestamp']['output']>;
  discount_amount?: Maybe<Scalars['float8']['output']>;
  discount_percent?: Maybe<Scalars['float8']['output']>;
  discount_total?: Maybe<Scalars['float8']['output']>;
  due_date?: Maybe<Scalars['date']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  external_note?: Maybe<Scalars['String']['output']>;
  fin_invoice_document_id?: Maybe<Scalars['uuid']['output']>;
  fin_invoice_shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  has_tax: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  internal_id?: Maybe<Scalars['Int']['output']>;
  invoice_am_id?: Maybe<Scalars['uuid']['output']>;
  invoice_credit?: Maybe<Scalars['float8']['output']>;
  invoice_type?: Maybe<Scalars['String']['output']>;
  is_new_client: Scalars['Boolean']['output'];
  is_no_shipping?: Maybe<Scalars['Boolean']['output']>;
  is_recheck: Scalars['Boolean']['output'];
  is_recurrent?: Maybe<Scalars['Boolean']['output']>;
  is_send: Scalars['Boolean']['output'];
  is_share_commission?: Maybe<Scalars['Boolean']['output']>;
  is_shipping_same_billing?: Maybe<Scalars['Boolean']['output']>;
  is_whmcs_action?: Maybe<Scalars['Boolean']['output']>;
  last_payment_status?: Maybe<Scalars['String']['output']>;
  list_discount?: Maybe<Scalars['jsonb']['output']>;
  list_promotion_gift?: Maybe<Scalars['jsonb']['output']>;
  money_collect_updator_id?: Maybe<Scalars['uuid']['output']>;
  money_collector_id?: Maybe<Scalars['uuid']['output']>;
  multi_payment?: Maybe<Scalars['jsonb']['output']>;
  new_company?: Maybe<Scalars['jsonb']['output']>;
  new_payment?: Maybe<Scalars['jsonb']['output']>;
  new_shipping_address?: Maybe<Scalars['jsonb']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  note_attachments?: Maybe<Scalars['jsonb']['output']>;
  note_for_ae?: Maybe<Scalars['String']['output']>;
  object_id?: Maybe<Scalars['String']['output']>;
  payment_contact?: Maybe<Scalars['String']['output']>;
  payment_invoice_method_id?: Maybe<Scalars['uuid']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_owner_name?: Maybe<Scalars['String']['output']>;
  payment_relationship?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  promotion_code?: Maybe<Scalars['jsonb']['output']>;
  promotion_name?: Maybe<Scalars['jsonb']['output']>;
  recurrent_parent_invoice?: Maybe<Scalars['Int']['output']>;
  referral_id?: Maybe<Scalars['String']['output']>;
  referral_internal_id?: Maybe<Scalars['Int']['output']>;
  referrer_id?: Maybe<Scalars['String']['output']>;
  shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  shipping_note?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  sub_total?: Maybe<Scalars['float8']['output']>;
  tags?: Maybe<Scalars['jsonb']['output']>;
  tax?: Maybe<Scalars['float8']['output']>;
  tax2?: Maybe<Scalars['float8']['output']>;
  tax_price: Scalars['float8']['output'];
  taxrate?: Maybe<Scalars['float8']['output']>;
  taxrate2?: Maybe<Scalars['float8']['output']>;
  total_after_discount: Scalars['float8']['output'];
  total_after_tax: Scalars['float8']['output'];
  total_before_discount?: Maybe<Scalars['float8']['output']>;
  total_custom_fields?: Maybe<Scalars['jsonb']['output']>;
  total_price: Scalars['float8']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamp']['output'];
  updated_by_id?: Maybe<Scalars['uuid']['output']>;
  user?: Maybe<Crm_User>;
  userByCreatedById?: Maybe<Crm_User>;
  userByInvoiceAmId?: Maybe<Crm_User>;
  userByMoneyCollectUpdatorId?: Maybe<Crm_User>;
  userByMoneyCollectorId?: Maybe<Crm_User>;
  userByUpdatedById?: Maybe<Crm_User>;
  valid_until?: Maybe<Scalars['date']['output']>;
  voucher?: Maybe<Scalars['jsonb']['output']>;
  whmcs_order_id?: Maybe<Scalars['Int']['output']>;
};

export type Crm_Fin_InvoiceClient_Contact_InfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoiceList_DiscountArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoiceList_Promotion_GiftArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoiceMulti_PaymentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoiceNew_CompanyArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoiceNew_PaymentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoiceNew_Shipping_AddressArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoiceNote_AttachmentsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoicePromotion_CodeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoicePromotion_NameArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoiceTagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoiceTotal_Custom_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_InvoiceVoucherArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Crm_Fin_Invoice_Aggregate = {
  aggregate?: Maybe<Crm_Fin_Invoice_Aggregate_Fields>;
  nodes: Array<Crm_Fin_Invoice>;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp_Var_Samp>;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Avg = {
  arguments: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Bool_And = {
  arguments: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Corr = {
  arguments: Crm_Fin_Invoice_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Crm_Fin_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Max = {
  arguments: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Min = {
  arguments: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Sum = {
  arguments: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Crm_Fin_Invoice_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Crm_Fin_Invoice_Aggregate_Fields = {
  avg?: Maybe<Crm_Fin_Invoice_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Crm_Fin_Invoice_Max_Fields>;
  min?: Maybe<Crm_Fin_Invoice_Min_Fields>;
  stddev?: Maybe<Crm_Fin_Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Crm_Fin_Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crm_Fin_Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Crm_Fin_Invoice_Sum_Fields>;
  var_pop?: Maybe<Crm_Fin_Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Crm_Fin_Invoice_Var_Samp_Fields>;
  variance?: Maybe<Crm_Fin_Invoice_Variance_Fields>;
};

export type Crm_Fin_Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Crm_Fin_Invoice_Aggregate_Order_By = {
  avg?: InputMaybe<Crm_Fin_Invoice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crm_Fin_Invoice_Max_Order_By>;
  min?: InputMaybe<Crm_Fin_Invoice_Min_Order_By>;
  stddev?: InputMaybe<Crm_Fin_Invoice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Crm_Fin_Invoice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Crm_Fin_Invoice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Crm_Fin_Invoice_Sum_Order_By>;
  var_pop?: InputMaybe<Crm_Fin_Invoice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Crm_Fin_Invoice_Var_Samp_Order_By>;
  variance?: InputMaybe<Crm_Fin_Invoice_Variance_Order_By>;
};

export type Crm_Fin_Invoice_Avg_Fields = {
  balance?: Maybe<Scalars['Float']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  credit_use?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_percent?: Maybe<Scalars['Float']['output']>;
  discount_total?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  invoice_credit?: Maybe<Scalars['Float']['output']>;
  recurrent_parent_invoice?: Maybe<Scalars['Float']['output']>;
  referral_internal_id?: Maybe<Scalars['Float']['output']>;
  sub_total?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  tax2?: Maybe<Scalars['Float']['output']>;
  tax_price?: Maybe<Scalars['Float']['output']>;
  taxrate?: Maybe<Scalars['Float']['output']>;
  taxrate2?: Maybe<Scalars['Float']['output']>;
  total_after_discount?: Maybe<Scalars['Float']['output']>;
  total_after_tax?: Maybe<Scalars['Float']['output']>;
  total_before_discount?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  whmcs_order_id?: Maybe<Scalars['Float']['output']>;
};

export type Crm_Fin_Invoice_Avg_Order_By = {
  balance?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  credit_use?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_percent?: InputMaybe<Order_By>;
  discount_total?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice_credit?: InputMaybe<Order_By>;
  recurrent_parent_invoice?: InputMaybe<Order_By>;
  referral_internal_id?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax2?: InputMaybe<Order_By>;
  tax_price?: InputMaybe<Order_By>;
  taxrate?: InputMaybe<Order_By>;
  taxrate2?: InputMaybe<Order_By>;
  total_after_discount?: InputMaybe<Order_By>;
  total_after_tax?: InputMaybe<Order_By>;
  total_before_discount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  whmcs_order_id?: InputMaybe<Order_By>;
};

export type Crm_Fin_Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_Fin_Invoice_Bool_Exp>>;
  _not?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_Fin_Invoice_Bool_Exp>>;
  allow_no_sign?: InputMaybe<Boolean_Comparison_Exp>;
  assigned_to?: InputMaybe<Uuid_Comparison_Exp>;
  balance?: InputMaybe<Float8_Comparison_Exp>;
  begin_date?: InputMaybe<Date_Comparison_Exp>;
  canceled_reason?: InputMaybe<String_Comparison_Exp>;
  client_company?: InputMaybe<Crm_Client_Company_Bool_Exp>;
  client_company_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_contact?: InputMaybe<Crm_Client_Contact_Bool_Exp>;
  client_contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_contact_info?: InputMaybe<Jsonb_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  contextual?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  credit?: InputMaybe<Float8_Comparison_Exp>;
  credit_use?: InputMaybe<Float8_Comparison_Exp>;
  date?: InputMaybe<Timestamp_Comparison_Exp>;
  date_paid?: InputMaybe<Timestamp_Comparison_Exp>;
  discount_amount?: InputMaybe<Float8_Comparison_Exp>;
  discount_percent?: InputMaybe<Float8_Comparison_Exp>;
  discount_total?: InputMaybe<Float8_Comparison_Exp>;
  due_date?: InputMaybe<Date_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  external_note?: InputMaybe<String_Comparison_Exp>;
  fin_invoice_document_id?: InputMaybe<Uuid_Comparison_Exp>;
  fin_invoice_shipping_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_tax?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_id?: InputMaybe<Int_Comparison_Exp>;
  invoice_am_id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_credit?: InputMaybe<Float8_Comparison_Exp>;
  invoice_type?: InputMaybe<String_Comparison_Exp>;
  is_new_client?: InputMaybe<Boolean_Comparison_Exp>;
  is_no_shipping?: InputMaybe<Boolean_Comparison_Exp>;
  is_recheck?: InputMaybe<Boolean_Comparison_Exp>;
  is_recurrent?: InputMaybe<Boolean_Comparison_Exp>;
  is_send?: InputMaybe<Boolean_Comparison_Exp>;
  is_share_commission?: InputMaybe<Boolean_Comparison_Exp>;
  is_shipping_same_billing?: InputMaybe<Boolean_Comparison_Exp>;
  is_whmcs_action?: InputMaybe<Boolean_Comparison_Exp>;
  last_payment_status?: InputMaybe<String_Comparison_Exp>;
  list_discount?: InputMaybe<Jsonb_Comparison_Exp>;
  list_promotion_gift?: InputMaybe<Jsonb_Comparison_Exp>;
  money_collect_updator_id?: InputMaybe<Uuid_Comparison_Exp>;
  money_collector_id?: InputMaybe<Uuid_Comparison_Exp>;
  multi_payment?: InputMaybe<Jsonb_Comparison_Exp>;
  new_company?: InputMaybe<Jsonb_Comparison_Exp>;
  new_payment?: InputMaybe<Jsonb_Comparison_Exp>;
  new_shipping_address?: InputMaybe<Jsonb_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  note_attachments?: InputMaybe<Jsonb_Comparison_Exp>;
  note_for_ae?: InputMaybe<String_Comparison_Exp>;
  object_id?: InputMaybe<String_Comparison_Exp>;
  payment_contact?: InputMaybe<String_Comparison_Exp>;
  payment_invoice_method_id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_method?: InputMaybe<String_Comparison_Exp>;
  payment_owner_name?: InputMaybe<String_Comparison_Exp>;
  payment_relationship?: InputMaybe<String_Comparison_Exp>;
  payment_type?: InputMaybe<String_Comparison_Exp>;
  promotion_code?: InputMaybe<Jsonb_Comparison_Exp>;
  promotion_name?: InputMaybe<Jsonb_Comparison_Exp>;
  recurrent_parent_invoice?: InputMaybe<Int_Comparison_Exp>;
  referral_id?: InputMaybe<String_Comparison_Exp>;
  referral_internal_id?: InputMaybe<Int_Comparison_Exp>;
  referrer_id?: InputMaybe<String_Comparison_Exp>;
  shipping_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  shipping_note?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  sub_total?: InputMaybe<Float8_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  tax?: InputMaybe<Float8_Comparison_Exp>;
  tax2?: InputMaybe<Float8_Comparison_Exp>;
  tax_price?: InputMaybe<Float8_Comparison_Exp>;
  taxrate?: InputMaybe<Float8_Comparison_Exp>;
  taxrate2?: InputMaybe<Float8_Comparison_Exp>;
  total_after_discount?: InputMaybe<Float8_Comparison_Exp>;
  total_after_tax?: InputMaybe<Float8_Comparison_Exp>;
  total_before_discount?: InputMaybe<Float8_Comparison_Exp>;
  total_custom_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  total_price?: InputMaybe<Float8_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Crm_User_Bool_Exp>;
  userByCreatedById?: InputMaybe<Crm_User_Bool_Exp>;
  userByInvoiceAmId?: InputMaybe<Crm_User_Bool_Exp>;
  userByMoneyCollectUpdatorId?: InputMaybe<Crm_User_Bool_Exp>;
  userByMoneyCollectorId?: InputMaybe<Crm_User_Bool_Exp>;
  userByUpdatedById?: InputMaybe<Crm_User_Bool_Exp>;
  valid_until?: InputMaybe<Date_Comparison_Exp>;
  voucher?: InputMaybe<Jsonb_Comparison_Exp>;
  whmcs_order_id?: InputMaybe<Int_Comparison_Exp>;
};

export type Crm_Fin_Invoice_Max_Fields = {
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  balance?: Maybe<Scalars['float8']['output']>;
  begin_date?: Maybe<Scalars['date']['output']>;
  canceled_reason?: Maybe<Scalars['String']['output']>;
  client_company_id?: Maybe<Scalars['uuid']['output']>;
  client_contact_id?: Maybe<Scalars['uuid']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  contextual?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by_id?: Maybe<Scalars['uuid']['output']>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  credit?: Maybe<Scalars['float8']['output']>;
  credit_use?: Maybe<Scalars['float8']['output']>;
  date?: Maybe<Scalars['timestamp']['output']>;
  date_paid?: Maybe<Scalars['timestamp']['output']>;
  discount_amount?: Maybe<Scalars['float8']['output']>;
  discount_percent?: Maybe<Scalars['float8']['output']>;
  discount_total?: Maybe<Scalars['float8']['output']>;
  due_date?: Maybe<Scalars['date']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  external_note?: Maybe<Scalars['String']['output']>;
  fin_invoice_document_id?: Maybe<Scalars['uuid']['output']>;
  fin_invoice_shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['Int']['output']>;
  invoice_am_id?: Maybe<Scalars['uuid']['output']>;
  invoice_credit?: Maybe<Scalars['float8']['output']>;
  invoice_type?: Maybe<Scalars['String']['output']>;
  last_payment_status?: Maybe<Scalars['String']['output']>;
  money_collect_updator_id?: Maybe<Scalars['uuid']['output']>;
  money_collector_id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  note_for_ae?: Maybe<Scalars['String']['output']>;
  object_id?: Maybe<Scalars['String']['output']>;
  payment_contact?: Maybe<Scalars['String']['output']>;
  payment_invoice_method_id?: Maybe<Scalars['uuid']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_owner_name?: Maybe<Scalars['String']['output']>;
  payment_relationship?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  recurrent_parent_invoice?: Maybe<Scalars['Int']['output']>;
  referral_id?: Maybe<Scalars['String']['output']>;
  referral_internal_id?: Maybe<Scalars['Int']['output']>;
  referrer_id?: Maybe<Scalars['String']['output']>;
  shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  shipping_note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_total?: Maybe<Scalars['float8']['output']>;
  tax?: Maybe<Scalars['float8']['output']>;
  tax2?: Maybe<Scalars['float8']['output']>;
  tax_price?: Maybe<Scalars['float8']['output']>;
  taxrate?: Maybe<Scalars['float8']['output']>;
  taxrate2?: Maybe<Scalars['float8']['output']>;
  total_after_discount?: Maybe<Scalars['float8']['output']>;
  total_after_tax?: Maybe<Scalars['float8']['output']>;
  total_before_discount?: Maybe<Scalars['float8']['output']>;
  total_price?: Maybe<Scalars['float8']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  updated_by_id?: Maybe<Scalars['uuid']['output']>;
  valid_until?: Maybe<Scalars['date']['output']>;
  whmcs_order_id?: Maybe<Scalars['Int']['output']>;
};

export type Crm_Fin_Invoice_Max_Order_By = {
  assigned_to?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  begin_date?: InputMaybe<Order_By>;
  canceled_reason?: InputMaybe<Order_By>;
  client_company_id?: InputMaybe<Order_By>;
  client_contact_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  contextual?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  credit_use?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  date_paid?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_percent?: InputMaybe<Order_By>;
  discount_total?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  external_note?: InputMaybe<Order_By>;
  fin_invoice_document_id?: InputMaybe<Order_By>;
  fin_invoice_shipping_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice_am_id?: InputMaybe<Order_By>;
  invoice_credit?: InputMaybe<Order_By>;
  invoice_type?: InputMaybe<Order_By>;
  last_payment_status?: InputMaybe<Order_By>;
  money_collect_updator_id?: InputMaybe<Order_By>;
  money_collector_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  note_for_ae?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  payment_contact?: InputMaybe<Order_By>;
  payment_invoice_method_id?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  payment_owner_name?: InputMaybe<Order_By>;
  payment_relationship?: InputMaybe<Order_By>;
  payment_type?: InputMaybe<Order_By>;
  recurrent_parent_invoice?: InputMaybe<Order_By>;
  referral_id?: InputMaybe<Order_By>;
  referral_internal_id?: InputMaybe<Order_By>;
  referrer_id?: InputMaybe<Order_By>;
  shipping_address_id?: InputMaybe<Order_By>;
  shipping_note?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax2?: InputMaybe<Order_By>;
  tax_price?: InputMaybe<Order_By>;
  taxrate?: InputMaybe<Order_By>;
  taxrate2?: InputMaybe<Order_By>;
  total_after_discount?: InputMaybe<Order_By>;
  total_after_tax?: InputMaybe<Order_By>;
  total_before_discount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
  whmcs_order_id?: InputMaybe<Order_By>;
};

export type Crm_Fin_Invoice_Min_Fields = {
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  balance?: Maybe<Scalars['float8']['output']>;
  begin_date?: Maybe<Scalars['date']['output']>;
  canceled_reason?: Maybe<Scalars['String']['output']>;
  client_company_id?: Maybe<Scalars['uuid']['output']>;
  client_contact_id?: Maybe<Scalars['uuid']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  contextual?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  created_by_id?: Maybe<Scalars['uuid']['output']>;
  creator_id?: Maybe<Scalars['uuid']['output']>;
  credit?: Maybe<Scalars['float8']['output']>;
  credit_use?: Maybe<Scalars['float8']['output']>;
  date?: Maybe<Scalars['timestamp']['output']>;
  date_paid?: Maybe<Scalars['timestamp']['output']>;
  discount_amount?: Maybe<Scalars['float8']['output']>;
  discount_percent?: Maybe<Scalars['float8']['output']>;
  discount_total?: Maybe<Scalars['float8']['output']>;
  due_date?: Maybe<Scalars['date']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  external_note?: Maybe<Scalars['String']['output']>;
  fin_invoice_document_id?: Maybe<Scalars['uuid']['output']>;
  fin_invoice_shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_id?: Maybe<Scalars['Int']['output']>;
  invoice_am_id?: Maybe<Scalars['uuid']['output']>;
  invoice_credit?: Maybe<Scalars['float8']['output']>;
  invoice_type?: Maybe<Scalars['String']['output']>;
  last_payment_status?: Maybe<Scalars['String']['output']>;
  money_collect_updator_id?: Maybe<Scalars['uuid']['output']>;
  money_collector_id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  note_for_ae?: Maybe<Scalars['String']['output']>;
  object_id?: Maybe<Scalars['String']['output']>;
  payment_contact?: Maybe<Scalars['String']['output']>;
  payment_invoice_method_id?: Maybe<Scalars['uuid']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_owner_name?: Maybe<Scalars['String']['output']>;
  payment_relationship?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  recurrent_parent_invoice?: Maybe<Scalars['Int']['output']>;
  referral_id?: Maybe<Scalars['String']['output']>;
  referral_internal_id?: Maybe<Scalars['Int']['output']>;
  referrer_id?: Maybe<Scalars['String']['output']>;
  shipping_address_id?: Maybe<Scalars['uuid']['output']>;
  shipping_note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_total?: Maybe<Scalars['float8']['output']>;
  tax?: Maybe<Scalars['float8']['output']>;
  tax2?: Maybe<Scalars['float8']['output']>;
  tax_price?: Maybe<Scalars['float8']['output']>;
  taxrate?: Maybe<Scalars['float8']['output']>;
  taxrate2?: Maybe<Scalars['float8']['output']>;
  total_after_discount?: Maybe<Scalars['float8']['output']>;
  total_after_tax?: Maybe<Scalars['float8']['output']>;
  total_before_discount?: Maybe<Scalars['float8']['output']>;
  total_price?: Maybe<Scalars['float8']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  updated_by_id?: Maybe<Scalars['uuid']['output']>;
  valid_until?: Maybe<Scalars['date']['output']>;
  whmcs_order_id?: Maybe<Scalars['Int']['output']>;
};

export type Crm_Fin_Invoice_Min_Order_By = {
  assigned_to?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  begin_date?: InputMaybe<Order_By>;
  canceled_reason?: InputMaybe<Order_By>;
  client_company_id?: InputMaybe<Order_By>;
  client_contact_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  contextual?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  credit_use?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  date_paid?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_percent?: InputMaybe<Order_By>;
  discount_total?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  external_note?: InputMaybe<Order_By>;
  fin_invoice_document_id?: InputMaybe<Order_By>;
  fin_invoice_shipping_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice_am_id?: InputMaybe<Order_By>;
  invoice_credit?: InputMaybe<Order_By>;
  invoice_type?: InputMaybe<Order_By>;
  last_payment_status?: InputMaybe<Order_By>;
  money_collect_updator_id?: InputMaybe<Order_By>;
  money_collector_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  note_for_ae?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  payment_contact?: InputMaybe<Order_By>;
  payment_invoice_method_id?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  payment_owner_name?: InputMaybe<Order_By>;
  payment_relationship?: InputMaybe<Order_By>;
  payment_type?: InputMaybe<Order_By>;
  recurrent_parent_invoice?: InputMaybe<Order_By>;
  referral_id?: InputMaybe<Order_By>;
  referral_internal_id?: InputMaybe<Order_By>;
  referrer_id?: InputMaybe<Order_By>;
  shipping_address_id?: InputMaybe<Order_By>;
  shipping_note?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax2?: InputMaybe<Order_By>;
  tax_price?: InputMaybe<Order_By>;
  taxrate?: InputMaybe<Order_By>;
  taxrate2?: InputMaybe<Order_By>;
  total_after_discount?: InputMaybe<Order_By>;
  total_after_tax?: InputMaybe<Order_By>;
  total_before_discount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
  whmcs_order_id?: InputMaybe<Order_By>;
};

export type Crm_Fin_Invoice_Order_By = {
  allow_no_sign?: InputMaybe<Order_By>;
  assigned_to?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  begin_date?: InputMaybe<Order_By>;
  canceled_reason?: InputMaybe<Order_By>;
  client_company?: InputMaybe<Crm_Client_Company_Order_By>;
  client_company_id?: InputMaybe<Order_By>;
  client_contact?: InputMaybe<Crm_Client_Contact_Order_By>;
  client_contact_id?: InputMaybe<Order_By>;
  client_contact_info?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  contextual?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  credit_use?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  date_paid?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_percent?: InputMaybe<Order_By>;
  discount_total?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  external_note?: InputMaybe<Order_By>;
  fin_invoice_document_id?: InputMaybe<Order_By>;
  fin_invoice_shipping_address_id?: InputMaybe<Order_By>;
  has_tax?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice_am_id?: InputMaybe<Order_By>;
  invoice_credit?: InputMaybe<Order_By>;
  invoice_type?: InputMaybe<Order_By>;
  is_new_client?: InputMaybe<Order_By>;
  is_no_shipping?: InputMaybe<Order_By>;
  is_recheck?: InputMaybe<Order_By>;
  is_recurrent?: InputMaybe<Order_By>;
  is_send?: InputMaybe<Order_By>;
  is_share_commission?: InputMaybe<Order_By>;
  is_shipping_same_billing?: InputMaybe<Order_By>;
  is_whmcs_action?: InputMaybe<Order_By>;
  last_payment_status?: InputMaybe<Order_By>;
  list_discount?: InputMaybe<Order_By>;
  list_promotion_gift?: InputMaybe<Order_By>;
  money_collect_updator_id?: InputMaybe<Order_By>;
  money_collector_id?: InputMaybe<Order_By>;
  multi_payment?: InputMaybe<Order_By>;
  new_company?: InputMaybe<Order_By>;
  new_payment?: InputMaybe<Order_By>;
  new_shipping_address?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  note_attachments?: InputMaybe<Order_By>;
  note_for_ae?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  payment_contact?: InputMaybe<Order_By>;
  payment_invoice_method_id?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  payment_owner_name?: InputMaybe<Order_By>;
  payment_relationship?: InputMaybe<Order_By>;
  payment_type?: InputMaybe<Order_By>;
  promotion_code?: InputMaybe<Order_By>;
  promotion_name?: InputMaybe<Order_By>;
  recurrent_parent_invoice?: InputMaybe<Order_By>;
  referral_id?: InputMaybe<Order_By>;
  referral_internal_id?: InputMaybe<Order_By>;
  referrer_id?: InputMaybe<Order_By>;
  shipping_address_id?: InputMaybe<Order_By>;
  shipping_note?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax2?: InputMaybe<Order_By>;
  tax_price?: InputMaybe<Order_By>;
  taxrate?: InputMaybe<Order_By>;
  taxrate2?: InputMaybe<Order_By>;
  total_after_discount?: InputMaybe<Order_By>;
  total_after_tax?: InputMaybe<Order_By>;
  total_before_discount?: InputMaybe<Order_By>;
  total_custom_fields?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Crm_User_Order_By>;
  userByCreatedById?: InputMaybe<Crm_User_Order_By>;
  userByInvoiceAmId?: InputMaybe<Crm_User_Order_By>;
  userByMoneyCollectUpdatorId?: InputMaybe<Crm_User_Order_By>;
  userByMoneyCollectorId?: InputMaybe<Crm_User_Order_By>;
  userByUpdatedById?: InputMaybe<Crm_User_Order_By>;
  valid_until?: InputMaybe<Order_By>;
  voucher?: InputMaybe<Order_By>;
  whmcs_order_id?: InputMaybe<Order_By>;
};

export enum Crm_Fin_Invoice_Select_Column {
  AllowNoSign = 'allow_no_sign',
  AssignedTo = 'assigned_to',
  Balance = 'balance',
  BeginDate = 'begin_date',
  CanceledReason = 'canceled_reason',
  ClientCompanyId = 'client_company_id',
  ClientContactId = 'client_contact_id',
  ClientContactInfo = 'client_contact_info',
  Code = 'code',
  Contextual = 'contextual',
  CreatedAt = 'created_at',
  CreatedById = 'created_by_id',
  CreatorId = 'creator_id',
  Credit = 'credit',
  CreditUse = 'credit_use',
  Date = 'date',
  DatePaid = 'date_paid',
  DiscountAmount = 'discount_amount',
  DiscountPercent = 'discount_percent',
  DiscountTotal = 'discount_total',
  DueDate = 'due_date',
  EndDate = 'end_date',
  ExternalNote = 'external_note',
  FinInvoiceDocumentId = 'fin_invoice_document_id',
  FinInvoiceShippingAddressId = 'fin_invoice_shipping_address_id',
  HasTax = 'has_tax',
  Id = 'id',
  InternalId = 'internal_id',
  InvoiceAmId = 'invoice_am_id',
  InvoiceCredit = 'invoice_credit',
  InvoiceType = 'invoice_type',
  IsNewClient = 'is_new_client',
  IsNoShipping = 'is_no_shipping',
  IsRecheck = 'is_recheck',
  IsRecurrent = 'is_recurrent',
  IsSend = 'is_send',
  IsShareCommission = 'is_share_commission',
  IsShippingSameBilling = 'is_shipping_same_billing',
  IsWhmcsAction = 'is_whmcs_action',
  LastPaymentStatus = 'last_payment_status',
  ListDiscount = 'list_discount',
  ListPromotionGift = 'list_promotion_gift',
  MoneyCollectUpdatorId = 'money_collect_updator_id',
  MoneyCollectorId = 'money_collector_id',
  MultiPayment = 'multi_payment',
  NewCompany = 'new_company',
  NewPayment = 'new_payment',
  NewShippingAddress = 'new_shipping_address',
  Note = 'note',
  NoteAttachments = 'note_attachments',
  NoteForAe = 'note_for_ae',
  ObjectId = 'object_id',
  PaymentContact = 'payment_contact',
  PaymentInvoiceMethodId = 'payment_invoice_method_id',
  PaymentMethod = 'payment_method',
  PaymentOwnerName = 'payment_owner_name',
  PaymentRelationship = 'payment_relationship',
  PaymentType = 'payment_type',
  PromotionCode = 'promotion_code',
  PromotionName = 'promotion_name',
  RecurrentParentInvoice = 'recurrent_parent_invoice',
  ReferralId = 'referral_id',
  ReferralInternalId = 'referral_internal_id',
  ReferrerId = 'referrer_id',
  ShippingAddressId = 'shipping_address_id',
  ShippingNote = 'shipping_note',
  Status = 'status',
  SubTotal = 'sub_total',
  Tags = 'tags',
  Tax = 'tax',
  Tax2 = 'tax2',
  TaxPrice = 'tax_price',
  Taxrate = 'taxrate',
  Taxrate2 = 'taxrate2',
  TotalAfterDiscount = 'total_after_discount',
  TotalAfterTax = 'total_after_tax',
  TotalBeforeDiscount = 'total_before_discount',
  TotalCustomFields = 'total_custom_fields',
  TotalPrice = 'total_price',
  Type = 'type',
  UpdatedAt = 'updated_at',
  UpdatedById = 'updated_by_id',
  ValidUntil = 'valid_until',
  Voucher = 'voucher',
  WhmcsOrderId = 'whmcs_order_id',
}

export enum Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  Balance = 'balance',
  Credit = 'credit',
  CreditUse = 'credit_use',
  DiscountAmount = 'discount_amount',
  DiscountPercent = 'discount_percent',
  DiscountTotal = 'discount_total',
  InvoiceCredit = 'invoice_credit',
  SubTotal = 'sub_total',
  Tax = 'tax',
  Tax2 = 'tax2',
  TaxPrice = 'tax_price',
  Taxrate = 'taxrate',
  Taxrate2 = 'taxrate2',
  TotalAfterDiscount = 'total_after_discount',
  TotalAfterTax = 'total_after_tax',
  TotalBeforeDiscount = 'total_before_discount',
  TotalPrice = 'total_price',
}

export enum Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  AllowNoSign = 'allow_no_sign',
  HasTax = 'has_tax',
  IsNewClient = 'is_new_client',
  IsNoShipping = 'is_no_shipping',
  IsRecheck = 'is_recheck',
  IsRecurrent = 'is_recurrent',
  IsSend = 'is_send',
  IsShareCommission = 'is_share_commission',
  IsShippingSameBilling = 'is_shipping_same_billing',
  IsWhmcsAction = 'is_whmcs_action',
}

export enum Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  AllowNoSign = 'allow_no_sign',
  HasTax = 'has_tax',
  IsNewClient = 'is_new_client',
  IsNoShipping = 'is_no_shipping',
  IsRecheck = 'is_recheck',
  IsRecurrent = 'is_recurrent',
  IsSend = 'is_send',
  IsShareCommission = 'is_share_commission',
  IsShippingSameBilling = 'is_shipping_same_billing',
  IsWhmcsAction = 'is_whmcs_action',
}

export enum Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  Balance = 'balance',
  Credit = 'credit',
  CreditUse = 'credit_use',
  DiscountAmount = 'discount_amount',
  DiscountPercent = 'discount_percent',
  DiscountTotal = 'discount_total',
  InvoiceCredit = 'invoice_credit',
  SubTotal = 'sub_total',
  Tax = 'tax',
  Tax2 = 'tax2',
  TaxPrice = 'tax_price',
  Taxrate = 'taxrate',
  Taxrate2 = 'taxrate2',
  TotalAfterDiscount = 'total_after_discount',
  TotalAfterTax = 'total_after_tax',
  TotalBeforeDiscount = 'total_before_discount',
  TotalPrice = 'total_price',
}

export enum Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  Balance = 'balance',
  Credit = 'credit',
  CreditUse = 'credit_use',
  DiscountAmount = 'discount_amount',
  DiscountPercent = 'discount_percent',
  DiscountTotal = 'discount_total',
  InvoiceCredit = 'invoice_credit',
  SubTotal = 'sub_total',
  Tax = 'tax',
  Tax2 = 'tax2',
  TaxPrice = 'tax_price',
  Taxrate = 'taxrate',
  Taxrate2 = 'taxrate2',
  TotalAfterDiscount = 'total_after_discount',
  TotalAfterTax = 'total_after_tax',
  TotalBeforeDiscount = 'total_before_discount',
  TotalPrice = 'total_price',
}

export enum Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Max_Arguments_Columns {
  Balance = 'balance',
  Credit = 'credit',
  CreditUse = 'credit_use',
  DiscountAmount = 'discount_amount',
  DiscountPercent = 'discount_percent',
  DiscountTotal = 'discount_total',
  InvoiceCredit = 'invoice_credit',
  SubTotal = 'sub_total',
  Tax = 'tax',
  Tax2 = 'tax2',
  TaxPrice = 'tax_price',
  Taxrate = 'taxrate',
  Taxrate2 = 'taxrate2',
  TotalAfterDiscount = 'total_after_discount',
  TotalAfterTax = 'total_after_tax',
  TotalBeforeDiscount = 'total_before_discount',
  TotalPrice = 'total_price',
}

export enum Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Min_Arguments_Columns {
  Balance = 'balance',
  Credit = 'credit',
  CreditUse = 'credit_use',
  DiscountAmount = 'discount_amount',
  DiscountPercent = 'discount_percent',
  DiscountTotal = 'discount_total',
  InvoiceCredit = 'invoice_credit',
  SubTotal = 'sub_total',
  Tax = 'tax',
  Tax2 = 'tax2',
  TaxPrice = 'tax_price',
  Taxrate = 'taxrate',
  Taxrate2 = 'taxrate2',
  TotalAfterDiscount = 'total_after_discount',
  TotalAfterTax = 'total_after_tax',
  TotalBeforeDiscount = 'total_before_discount',
  TotalPrice = 'total_price',
}

export enum Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  Balance = 'balance',
  Credit = 'credit',
  CreditUse = 'credit_use',
  DiscountAmount = 'discount_amount',
  DiscountPercent = 'discount_percent',
  DiscountTotal = 'discount_total',
  InvoiceCredit = 'invoice_credit',
  SubTotal = 'sub_total',
  Tax = 'tax',
  Tax2 = 'tax2',
  TaxPrice = 'tax_price',
  Taxrate = 'taxrate',
  Taxrate2 = 'taxrate2',
  TotalAfterDiscount = 'total_after_discount',
  TotalAfterTax = 'total_after_tax',
  TotalBeforeDiscount = 'total_before_discount',
  TotalPrice = 'total_price',
}

export enum Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  Balance = 'balance',
  Credit = 'credit',
  CreditUse = 'credit_use',
  DiscountAmount = 'discount_amount',
  DiscountPercent = 'discount_percent',
  DiscountTotal = 'discount_total',
  InvoiceCredit = 'invoice_credit',
  SubTotal = 'sub_total',
  Tax = 'tax',
  Tax2 = 'tax2',
  TaxPrice = 'tax_price',
  Taxrate = 'taxrate',
  Taxrate2 = 'taxrate2',
  TotalAfterDiscount = 'total_after_discount',
  TotalAfterTax = 'total_after_tax',
  TotalBeforeDiscount = 'total_before_discount',
  TotalPrice = 'total_price',
}

export enum Crm_Fin_Invoice_Select_Column_Fin_Invoice_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  Balance = 'balance',
  Credit = 'credit',
  CreditUse = 'credit_use',
  DiscountAmount = 'discount_amount',
  DiscountPercent = 'discount_percent',
  DiscountTotal = 'discount_total',
  InvoiceCredit = 'invoice_credit',
  SubTotal = 'sub_total',
  Tax = 'tax',
  Tax2 = 'tax2',
  TaxPrice = 'tax_price',
  Taxrate = 'taxrate',
  Taxrate2 = 'taxrate2',
  TotalAfterDiscount = 'total_after_discount',
  TotalAfterTax = 'total_after_tax',
  TotalBeforeDiscount = 'total_before_discount',
  TotalPrice = 'total_price',
}

export type Crm_Fin_Invoice_Stddev_Fields = {
  balance?: Maybe<Scalars['Float']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  credit_use?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_percent?: Maybe<Scalars['Float']['output']>;
  discount_total?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  invoice_credit?: Maybe<Scalars['Float']['output']>;
  recurrent_parent_invoice?: Maybe<Scalars['Float']['output']>;
  referral_internal_id?: Maybe<Scalars['Float']['output']>;
  sub_total?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  tax2?: Maybe<Scalars['Float']['output']>;
  tax_price?: Maybe<Scalars['Float']['output']>;
  taxrate?: Maybe<Scalars['Float']['output']>;
  taxrate2?: Maybe<Scalars['Float']['output']>;
  total_after_discount?: Maybe<Scalars['Float']['output']>;
  total_after_tax?: Maybe<Scalars['Float']['output']>;
  total_before_discount?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  whmcs_order_id?: Maybe<Scalars['Float']['output']>;
};

export type Crm_Fin_Invoice_Stddev_Order_By = {
  balance?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  credit_use?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_percent?: InputMaybe<Order_By>;
  discount_total?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice_credit?: InputMaybe<Order_By>;
  recurrent_parent_invoice?: InputMaybe<Order_By>;
  referral_internal_id?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax2?: InputMaybe<Order_By>;
  tax_price?: InputMaybe<Order_By>;
  taxrate?: InputMaybe<Order_By>;
  taxrate2?: InputMaybe<Order_By>;
  total_after_discount?: InputMaybe<Order_By>;
  total_after_tax?: InputMaybe<Order_By>;
  total_before_discount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  whmcs_order_id?: InputMaybe<Order_By>;
};

export type Crm_Fin_Invoice_Stddev_Pop_Fields = {
  balance?: Maybe<Scalars['Float']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  credit_use?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_percent?: Maybe<Scalars['Float']['output']>;
  discount_total?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  invoice_credit?: Maybe<Scalars['Float']['output']>;
  recurrent_parent_invoice?: Maybe<Scalars['Float']['output']>;
  referral_internal_id?: Maybe<Scalars['Float']['output']>;
  sub_total?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  tax2?: Maybe<Scalars['Float']['output']>;
  tax_price?: Maybe<Scalars['Float']['output']>;
  taxrate?: Maybe<Scalars['Float']['output']>;
  taxrate2?: Maybe<Scalars['Float']['output']>;
  total_after_discount?: Maybe<Scalars['Float']['output']>;
  total_after_tax?: Maybe<Scalars['Float']['output']>;
  total_before_discount?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  whmcs_order_id?: Maybe<Scalars['Float']['output']>;
};

export type Crm_Fin_Invoice_Stddev_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  credit_use?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_percent?: InputMaybe<Order_By>;
  discount_total?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice_credit?: InputMaybe<Order_By>;
  recurrent_parent_invoice?: InputMaybe<Order_By>;
  referral_internal_id?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax2?: InputMaybe<Order_By>;
  tax_price?: InputMaybe<Order_By>;
  taxrate?: InputMaybe<Order_By>;
  taxrate2?: InputMaybe<Order_By>;
  total_after_discount?: InputMaybe<Order_By>;
  total_after_tax?: InputMaybe<Order_By>;
  total_before_discount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  whmcs_order_id?: InputMaybe<Order_By>;
};

export type Crm_Fin_Invoice_Stddev_Samp_Fields = {
  balance?: Maybe<Scalars['Float']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  credit_use?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_percent?: Maybe<Scalars['Float']['output']>;
  discount_total?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  invoice_credit?: Maybe<Scalars['Float']['output']>;
  recurrent_parent_invoice?: Maybe<Scalars['Float']['output']>;
  referral_internal_id?: Maybe<Scalars['Float']['output']>;
  sub_total?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  tax2?: Maybe<Scalars['Float']['output']>;
  tax_price?: Maybe<Scalars['Float']['output']>;
  taxrate?: Maybe<Scalars['Float']['output']>;
  taxrate2?: Maybe<Scalars['Float']['output']>;
  total_after_discount?: Maybe<Scalars['Float']['output']>;
  total_after_tax?: Maybe<Scalars['Float']['output']>;
  total_before_discount?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  whmcs_order_id?: Maybe<Scalars['Float']['output']>;
};

export type Crm_Fin_Invoice_Stddev_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  credit_use?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_percent?: InputMaybe<Order_By>;
  discount_total?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice_credit?: InputMaybe<Order_By>;
  recurrent_parent_invoice?: InputMaybe<Order_By>;
  referral_internal_id?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax2?: InputMaybe<Order_By>;
  tax_price?: InputMaybe<Order_By>;
  taxrate?: InputMaybe<Order_By>;
  taxrate2?: InputMaybe<Order_By>;
  total_after_discount?: InputMaybe<Order_By>;
  total_after_tax?: InputMaybe<Order_By>;
  total_before_discount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  whmcs_order_id?: InputMaybe<Order_By>;
};

export type Crm_Fin_Invoice_Sum_Fields = {
  balance?: Maybe<Scalars['float8']['output']>;
  credit?: Maybe<Scalars['float8']['output']>;
  credit_use?: Maybe<Scalars['float8']['output']>;
  discount_amount?: Maybe<Scalars['float8']['output']>;
  discount_percent?: Maybe<Scalars['float8']['output']>;
  discount_total?: Maybe<Scalars['float8']['output']>;
  internal_id?: Maybe<Scalars['Int']['output']>;
  invoice_credit?: Maybe<Scalars['float8']['output']>;
  recurrent_parent_invoice?: Maybe<Scalars['Int']['output']>;
  referral_internal_id?: Maybe<Scalars['Int']['output']>;
  sub_total?: Maybe<Scalars['float8']['output']>;
  tax?: Maybe<Scalars['float8']['output']>;
  tax2?: Maybe<Scalars['float8']['output']>;
  tax_price?: Maybe<Scalars['float8']['output']>;
  taxrate?: Maybe<Scalars['float8']['output']>;
  taxrate2?: Maybe<Scalars['float8']['output']>;
  total_after_discount?: Maybe<Scalars['float8']['output']>;
  total_after_tax?: Maybe<Scalars['float8']['output']>;
  total_before_discount?: Maybe<Scalars['float8']['output']>;
  total_price?: Maybe<Scalars['float8']['output']>;
  whmcs_order_id?: Maybe<Scalars['Int']['output']>;
};

export type Crm_Fin_Invoice_Sum_Order_By = {
  balance?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  credit_use?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_percent?: InputMaybe<Order_By>;
  discount_total?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice_credit?: InputMaybe<Order_By>;
  recurrent_parent_invoice?: InputMaybe<Order_By>;
  referral_internal_id?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax2?: InputMaybe<Order_By>;
  tax_price?: InputMaybe<Order_By>;
  taxrate?: InputMaybe<Order_By>;
  taxrate2?: InputMaybe<Order_By>;
  total_after_discount?: InputMaybe<Order_By>;
  total_after_tax?: InputMaybe<Order_By>;
  total_before_discount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  whmcs_order_id?: InputMaybe<Order_By>;
};

export type Crm_Fin_Invoice_Var_Pop_Fields = {
  balance?: Maybe<Scalars['Float']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  credit_use?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_percent?: Maybe<Scalars['Float']['output']>;
  discount_total?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  invoice_credit?: Maybe<Scalars['Float']['output']>;
  recurrent_parent_invoice?: Maybe<Scalars['Float']['output']>;
  referral_internal_id?: Maybe<Scalars['Float']['output']>;
  sub_total?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  tax2?: Maybe<Scalars['Float']['output']>;
  tax_price?: Maybe<Scalars['Float']['output']>;
  taxrate?: Maybe<Scalars['Float']['output']>;
  taxrate2?: Maybe<Scalars['Float']['output']>;
  total_after_discount?: Maybe<Scalars['Float']['output']>;
  total_after_tax?: Maybe<Scalars['Float']['output']>;
  total_before_discount?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  whmcs_order_id?: Maybe<Scalars['Float']['output']>;
};

export type Crm_Fin_Invoice_Var_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  credit_use?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_percent?: InputMaybe<Order_By>;
  discount_total?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice_credit?: InputMaybe<Order_By>;
  recurrent_parent_invoice?: InputMaybe<Order_By>;
  referral_internal_id?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax2?: InputMaybe<Order_By>;
  tax_price?: InputMaybe<Order_By>;
  taxrate?: InputMaybe<Order_By>;
  taxrate2?: InputMaybe<Order_By>;
  total_after_discount?: InputMaybe<Order_By>;
  total_after_tax?: InputMaybe<Order_By>;
  total_before_discount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  whmcs_order_id?: InputMaybe<Order_By>;
};

export type Crm_Fin_Invoice_Var_Samp_Fields = {
  balance?: Maybe<Scalars['Float']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  credit_use?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_percent?: Maybe<Scalars['Float']['output']>;
  discount_total?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  invoice_credit?: Maybe<Scalars['Float']['output']>;
  recurrent_parent_invoice?: Maybe<Scalars['Float']['output']>;
  referral_internal_id?: Maybe<Scalars['Float']['output']>;
  sub_total?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  tax2?: Maybe<Scalars['Float']['output']>;
  tax_price?: Maybe<Scalars['Float']['output']>;
  taxrate?: Maybe<Scalars['Float']['output']>;
  taxrate2?: Maybe<Scalars['Float']['output']>;
  total_after_discount?: Maybe<Scalars['Float']['output']>;
  total_after_tax?: Maybe<Scalars['Float']['output']>;
  total_before_discount?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  whmcs_order_id?: Maybe<Scalars['Float']['output']>;
};

export type Crm_Fin_Invoice_Var_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  credit_use?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_percent?: InputMaybe<Order_By>;
  discount_total?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice_credit?: InputMaybe<Order_By>;
  recurrent_parent_invoice?: InputMaybe<Order_By>;
  referral_internal_id?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax2?: InputMaybe<Order_By>;
  tax_price?: InputMaybe<Order_By>;
  taxrate?: InputMaybe<Order_By>;
  taxrate2?: InputMaybe<Order_By>;
  total_after_discount?: InputMaybe<Order_By>;
  total_after_tax?: InputMaybe<Order_By>;
  total_before_discount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  whmcs_order_id?: InputMaybe<Order_By>;
};

export type Crm_Fin_Invoice_Variance_Fields = {
  balance?: Maybe<Scalars['Float']['output']>;
  credit?: Maybe<Scalars['Float']['output']>;
  credit_use?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discount_percent?: Maybe<Scalars['Float']['output']>;
  discount_total?: Maybe<Scalars['Float']['output']>;
  internal_id?: Maybe<Scalars['Float']['output']>;
  invoice_credit?: Maybe<Scalars['Float']['output']>;
  recurrent_parent_invoice?: Maybe<Scalars['Float']['output']>;
  referral_internal_id?: Maybe<Scalars['Float']['output']>;
  sub_total?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  tax2?: Maybe<Scalars['Float']['output']>;
  tax_price?: Maybe<Scalars['Float']['output']>;
  taxrate?: Maybe<Scalars['Float']['output']>;
  taxrate2?: Maybe<Scalars['Float']['output']>;
  total_after_discount?: Maybe<Scalars['Float']['output']>;
  total_after_tax?: Maybe<Scalars['Float']['output']>;
  total_before_discount?: Maybe<Scalars['Float']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  whmcs_order_id?: Maybe<Scalars['Float']['output']>;
};

export type Crm_Fin_Invoice_Variance_Order_By = {
  balance?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  credit_use?: InputMaybe<Order_By>;
  discount_amount?: InputMaybe<Order_By>;
  discount_percent?: InputMaybe<Order_By>;
  discount_total?: InputMaybe<Order_By>;
  internal_id?: InputMaybe<Order_By>;
  invoice_credit?: InputMaybe<Order_By>;
  recurrent_parent_invoice?: InputMaybe<Order_By>;
  referral_internal_id?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax2?: InputMaybe<Order_By>;
  tax_price?: InputMaybe<Order_By>;
  taxrate?: InputMaybe<Order_By>;
  taxrate2?: InputMaybe<Order_By>;
  total_after_discount?: InputMaybe<Order_By>;
  total_after_tax?: InputMaybe<Order_By>;
  total_before_discount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  whmcs_order_id?: InputMaybe<Order_By>;
};

export type Crm_Generate_Login_Url_Input = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['uuid']['input'];
};

export type Crm_Reset_Gift_Card_Input = {
  gift_card_id: Scalars['uuid']['input'];
};

export type Crm_Update_Gift_Card_Input = {
  current_balance: Scalars['Int']['input'];
  gift_card_id: Scalars['uuid']['input'];
  price: Scalars['Int']['input'];
  status: Scalars['String']['input'];
};

export type Crm_User = {
  avatar_link?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  finInvoicesByCreatedById: Array<Crm_Fin_Invoice>;
  finInvoicesByCreatedById_aggregate: Crm_Fin_Invoice_Aggregate;
  finInvoicesByInvoiceAmId: Array<Crm_Fin_Invoice>;
  finInvoicesByInvoiceAmId_aggregate: Crm_Fin_Invoice_Aggregate;
  finInvoicesByMoneyCollectUpdatorId: Array<Crm_Fin_Invoice>;
  finInvoicesByMoneyCollectUpdatorId_aggregate: Crm_Fin_Invoice_Aggregate;
  finInvoicesByMoneyCollectorId: Array<Crm_Fin_Invoice>;
  finInvoicesByMoneyCollectorId_aggregate: Crm_Fin_Invoice_Aggregate;
  finInvoicesByUpdatedById: Array<Crm_Fin_Invoice>;
  finInvoicesByUpdatedById_aggregate: Crm_Fin_Invoice_Aggregate;
  fin_invoices: Array<Crm_Fin_Invoice>;
  fin_invoices_aggregate: Crm_Fin_Invoice_Aggregate;
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Crm_UserFinInvoicesByCreatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_UserFinInvoicesByCreatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_UserFinInvoicesByInvoiceAmIdArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_UserFinInvoicesByInvoiceAmId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_UserFinInvoicesByMoneyCollectUpdatorIdArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_UserFinInvoicesByMoneyCollectUpdatorId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_UserFinInvoicesByMoneyCollectorIdArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_UserFinInvoicesByMoneyCollectorId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_UserFinInvoicesByUpdatedByIdArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_UserFinInvoicesByUpdatedById_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_UserFin_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_UserFin_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crm_Fin_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Crm_Fin_Invoice_Order_By>>;
  where?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
};

export type Crm_User_Bool_Exp = {
  _and?: InputMaybe<Array<Crm_User_Bool_Exp>>;
  _not?: InputMaybe<Crm_User_Bool_Exp>;
  _or?: InputMaybe<Array<Crm_User_Bool_Exp>>;
  avatar_link?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  finInvoicesByCreatedById?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  finInvoicesByCreatedById_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp>;
  finInvoicesByInvoiceAmId?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  finInvoicesByInvoiceAmId_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp>;
  finInvoicesByMoneyCollectUpdatorId?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  finInvoicesByMoneyCollectUpdatorId_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp>;
  finInvoicesByMoneyCollectorId?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  finInvoicesByMoneyCollectorId_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp>;
  finInvoicesByUpdatedById?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  finInvoicesByUpdatedById_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp>;
  fin_invoices?: InputMaybe<Crm_Fin_Invoice_Bool_Exp>;
  fin_invoices_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

export type Crm_User_Order_By = {
  avatar_link?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  finInvoicesByCreatedById_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Order_By>;
  finInvoicesByInvoiceAmId_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Order_By>;
  finInvoicesByMoneyCollectUpdatorId_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Order_By>;
  finInvoicesByMoneyCollectorId_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Order_By>;
  finInvoicesByUpdatedById_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Order_By>;
  fin_invoices_aggregate?: InputMaybe<Crm_Fin_Invoice_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

export enum Crm_User_Select_Column {
  AvatarLink = 'avatar_link',
  Email = 'email',
  Id = 'id',
  Name = 'name',
}

export type Customer = {
  created_at: Scalars['timestamptz']['output'];
  customer_companies: Array<Customer_Company>;
  customer_companies_aggregate: Customer_Company_Aggregate;
  id: Scalars['uuid']['output'];
  phone_number: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

export type CustomerCustomer_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Customer_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Company_Order_By>>;
  where?: InputMaybe<Customer_Company_Bool_Exp>;
};

export type CustomerCustomer_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customer_Company_Order_By>>;
  where?: InputMaybe<Customer_Company_Bool_Exp>;
};

export type Customer_Aggregate = {
  aggregate?: Maybe<Customer_Aggregate_Fields>;
  nodes: Array<Customer>;
};

export type Customer_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Max_Fields>;
  min?: Maybe<Customer_Min_Fields>;
};

export type Customer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Customer_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Bool_Exp>>;
  _not?: InputMaybe<Customer_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_companies?: InputMaybe<Customer_Company_Bool_Exp>;
  customer_companies_aggregate?: InputMaybe<Customer_Company_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

export type Customer_Company = {
  created_at: Scalars['timestamptz']['output'];
  customer?: Maybe<Customer>;
  customer_id?: Maybe<Scalars['uuid']['output']>;
  gift_cards: Array<Gift_Card>;
  gift_cards_aggregate: Gift_Card_Aggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  whmcs_id: Scalars['Int']['output'];
};

export type Customer_CompanyGift_CardsArgs = {
  distinct_on?: InputMaybe<Array<Gift_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gift_Card_Order_By>>;
  where?: InputMaybe<Gift_Card_Bool_Exp>;
};

export type Customer_CompanyGift_Cards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gift_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gift_Card_Order_By>>;
  where?: InputMaybe<Gift_Card_Bool_Exp>;
};

export type Customer_Company_Aggregate = {
  aggregate?: Maybe<Customer_Company_Aggregate_Fields>;
  nodes: Array<Customer_Company>;
};

export type Customer_Company_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_Company_Aggregate_Bool_Exp_Count>;
};

export type Customer_Company_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Customer_Company_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Customer_Company_Aggregate_Fields = {
  avg?: Maybe<Customer_Company_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customer_Company_Max_Fields>;
  min?: Maybe<Customer_Company_Min_Fields>;
  stddev?: Maybe<Customer_Company_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Company_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Company_Sum_Fields>;
  var_pop?: Maybe<Customer_Company_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Company_Var_Samp_Fields>;
  variance?: Maybe<Customer_Company_Variance_Fields>;
};

export type Customer_Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Customer_Company_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Company_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Company_Max_Order_By>;
  min?: InputMaybe<Customer_Company_Min_Order_By>;
  stddev?: InputMaybe<Customer_Company_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customer_Company_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customer_Company_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customer_Company_Sum_Order_By>;
  var_pop?: InputMaybe<Customer_Company_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customer_Company_Var_Samp_Order_By>;
  variance?: InputMaybe<Customer_Company_Variance_Order_By>;
};

export type Customer_Company_Avg_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Customer_Company_Avg_Order_By = {
  whmcs_id?: InputMaybe<Order_By>;
};

export type Customer_Company_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Company_Bool_Exp>>;
  _not?: InputMaybe<Customer_Company_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Company_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer?: InputMaybe<Customer_Bool_Exp>;
  customer_id?: InputMaybe<Uuid_Comparison_Exp>;
  gift_cards?: InputMaybe<Gift_Card_Bool_Exp>;
  gift_cards_aggregate?: InputMaybe<Gift_Card_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  whmcs_id?: InputMaybe<Int_Comparison_Exp>;
};

export type Customer_Company_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Customer_Company_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Customer_Company_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Customer_Company_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Customer_Company_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer?: InputMaybe<Customer_Order_By>;
  customer_id?: InputMaybe<Order_By>;
  gift_cards_aggregate?: InputMaybe<Gift_Card_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export enum Customer_Company_Select_Column {
  CreatedAt = 'created_at',
  CustomerId = 'customer_id',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updated_at',
  WhmcsId = 'whmcs_id',
}

export type Customer_Company_Stddev_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Customer_Company_Stddev_Order_By = {
  whmcs_id?: InputMaybe<Order_By>;
};

export type Customer_Company_Stddev_Pop_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Customer_Company_Stddev_Pop_Order_By = {
  whmcs_id?: InputMaybe<Order_By>;
};

export type Customer_Company_Stddev_Samp_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Customer_Company_Stddev_Samp_Order_By = {
  whmcs_id?: InputMaybe<Order_By>;
};

export type Customer_Company_Sum_Fields = {
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Customer_Company_Sum_Order_By = {
  whmcs_id?: InputMaybe<Order_By>;
};

export type Customer_Company_Var_Pop_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Customer_Company_Var_Pop_Order_By = {
  whmcs_id?: InputMaybe<Order_By>;
};

export type Customer_Company_Var_Samp_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Customer_Company_Var_Samp_Order_By = {
  whmcs_id?: InputMaybe<Order_By>;
};

export type Customer_Company_Variance_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Customer_Company_Variance_Order_By = {
  whmcs_id?: InputMaybe<Order_By>;
};

export type Customer_Create_Customer_Input = {
  customer_name: Scalars['String']['input'];
  customer_phone: Scalars['String']['input'];
  whmcs_id: Scalars['Int']['input'];
};

export type Customer_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

export type Customer_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

export type Customer_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_companies_aggregate?: InputMaybe<Customer_Company_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

export type Customer_Posted = {
  id: Scalars['String']['output'];
};

export enum Customer_Select_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  PhoneNumber = 'phone_number',
  UpdatedAt = 'updated_at',
}

export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

export type Dts_Create_Gift_Card_Input = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
  whmcs_id: Scalars['Int']['input'];
};

export type Dts_Create_Multiple_Transaction_Input = {
  date: Scalars['String']['input'];
  dts_order_id?: InputMaybe<Scalars['Int']['input']>;
  transactions: Array<Dts_Create_Transaction_Input_Object>;
  type: Scalars['String']['input'];
};

export type Dts_Create_Transaction_Input = {
  balance_change: Scalars['Int']['input'];
  date: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dts_custom_field?: InputMaybe<Scalars['json']['input']>;
  dts_order_id?: InputMaybe<Scalars['Int']['input']>;
  gift_card_id: Scalars['uuid']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  whmcs_id: Scalars['Int']['input'];
};

export type Dts_Create_Transaction_Input_Object = {
  balance_change: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dts_custom_field?: InputMaybe<Scalars['json']['input']>;
  gift_card_id: Scalars['uuid']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  whmcs_id: Scalars['Int']['input'];
};

export type Dts_Generate_Login_Url_Input = {
  whmcs_id: Scalars['Int']['input'];
};

export type Dts_Import_Gift_Card_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  balance?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  status: Scalars['Int']['input'];
  whmcs_id: Scalars['Int']['input'];
};

export type Dts_Reset_Custom_Field_Gift_Card_Input = {
  gift_card_id: Scalars['uuid']['input'];
};

export type Dts_Reset_Custom_Field_Transaction_Input = {
  transaction_id: Scalars['uuid']['input'];
};

export type Dts_Revert_Transaction_Input = {
  date: Scalars['String']['input'];
  transaction_id: Scalars['uuid']['input'];
};

export type Dts_Update_Gift_Card_Input = {
  dts_custom_field?: InputMaybe<Scalars['json']['input']>;
  gift_card_id: Scalars['uuid']['input'];
};

export type Export_Gift_Card_Report_Request = {
  created_at: Scalars['timestamptz']['output'];
  crm_company: Array<Crm_Client_Company>;
  crm_user: Array<Crm_User>;
  gift_card_report?: Maybe<Storage_Object>;
  gift_card_report_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  redemption_transaction_report?: Maybe<Storage_Object>;
  redemption_transaction_report_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  top_up_transaction_report?: Maybe<Storage_Object>;
  top_up_transaction_report_id?: Maybe<Scalars['uuid']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
  whmcs_id: Scalars['Int']['output'];
};

export type Export_Gift_Card_Report_Request_Aggregate = {
  aggregate?: Maybe<Export_Gift_Card_Report_Request_Aggregate_Fields>;
  nodes: Array<Export_Gift_Card_Report_Request>;
};

export type Export_Gift_Card_Report_Request_Aggregate_Fields = {
  avg?: Maybe<Export_Gift_Card_Report_Request_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Export_Gift_Card_Report_Request_Max_Fields>;
  min?: Maybe<Export_Gift_Card_Report_Request_Min_Fields>;
  stddev?: Maybe<Export_Gift_Card_Report_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Export_Gift_Card_Report_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Export_Gift_Card_Report_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Export_Gift_Card_Report_Request_Sum_Fields>;
  var_pop?: Maybe<Export_Gift_Card_Report_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Export_Gift_Card_Report_Request_Var_Samp_Fields>;
  variance?: Maybe<Export_Gift_Card_Report_Request_Variance_Fields>;
};

export type Export_Gift_Card_Report_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Export_Gift_Card_Report_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Export_Gift_Card_Report_Request_Avg_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Export_Gift_Card_Report_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Export_Gift_Card_Report_Request_Bool_Exp>>;
  _not?: InputMaybe<Export_Gift_Card_Report_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Export_Gift_Card_Report_Request_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gift_card_report?: InputMaybe<Storage_Object_Bool_Exp>;
  gift_card_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  redemption_transaction_report?: InputMaybe<Storage_Object_Bool_Exp>;
  redemption_transaction_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  top_up_transaction_report?: InputMaybe<Storage_Object_Bool_Exp>;
  top_up_transaction_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  whmcs_id?: InputMaybe<Int_Comparison_Exp>;
};

export type Export_Gift_Card_Report_Request_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gift_card_report_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  redemption_transaction_report_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  top_up_transaction_report_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Export_Gift_Card_Report_Request_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gift_card_report_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  redemption_transaction_report_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  top_up_transaction_report_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Export_Gift_Card_Report_Request_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gift_card_report?: InputMaybe<Storage_Object_Order_By>;
  gift_card_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  redemption_transaction_report?: InputMaybe<Storage_Object_Order_By>;
  redemption_transaction_report_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  top_up_transaction_report?: InputMaybe<Storage_Object_Order_By>;
  top_up_transaction_report_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export enum Export_Gift_Card_Report_Request_Select_Column {
  CreatedAt = 'created_at',
  GiftCardReportId = 'gift_card_report_id',
  Id = 'id',
  RedemptionTransactionReportId = 'redemption_transaction_report_id',
  Status = 'status',
  TopUpTransactionReportId = 'top_up_transaction_report_id',
  Type = 'type',
  UpdatedAt = 'updated_at',
  UserId = 'user_id',
  WhmcsId = 'whmcs_id',
}

export type Export_Gift_Card_Report_Request_Stddev_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Export_Gift_Card_Report_Request_Stddev_Pop_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Export_Gift_Card_Report_Request_Stddev_Samp_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Export_Gift_Card_Report_Request_Sum_Fields = {
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Export_Gift_Card_Report_Request_Var_Pop_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Export_Gift_Card_Report_Request_Var_Samp_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Export_Gift_Card_Report_Request_Variance_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

export type Gci_Business_Create_Transaction_Input = {
  balance_change: Scalars['Int']['input'];
  customer_id?: InputMaybe<Scalars['uuid']['input']>;
  date: Scalars['String']['input'];
  description: Scalars['String']['input'];
  gift_card_id: Scalars['uuid']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  whmcs_id: Scalars['Int']['input'];
};

export type Gci_Business_Reset_Custom_Field_Gift_Card_Input = {
  gift_card_id: Scalars['uuid']['input'];
};

export type Gci_Business_Reset_Custom_Field_Transaction_Input = {
  transaction_id: Scalars['uuid']['input'];
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

export type Get_Transaction_Detail_Card_Info = {
  card_number_first_six?: Maybe<Scalars['String']['output']>;
  card_number_last_four?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  card_zip_code?: Maybe<Scalars['String']['output']>;
  cardholder_name?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['String']['output']>;
};

export type Get_Transaction_Detail_Company = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  business_phone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Get_Transaction_Detail_Discount = {
  value?: Maybe<Scalars['Int']['output']>;
};

export type Get_Transaction_Detail_Gift_Card = {
  code?: Maybe<Scalars['String']['output']>;
  pos_gift_card?: Maybe<Get_Transaction_Detail_Pos_Gift_Card>;
};

export type Get_Transaction_Detail_Input = {
  receipt_token: Scalars['String']['input'];
};

export type Get_Transaction_Detail_Payment_Method = {
  action?: Maybe<Scalars['String']['output']>;
  auth_code?: Maybe<Scalars['String']['output']>;
  card_info?: Maybe<Get_Transaction_Detail_Card_Info>;
  device_id?: Maybe<Scalars['String']['output']>;
  device_sn?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reference_id?: Maybe<Scalars['String']['output']>;
  trans_message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Get_Transaction_Detail_Pos_Gift_Card = {
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Get_Transaction_Detail_Signature = {
  base_uri?: Maybe<Scalars['String']['output']>;
};

export type Gift_Card = {
  b2b_gift_card_template_id?: Maybe<Scalars['uuid']['output']>;
  b2b_gift_card_template_no?: Maybe<Scalars['String']['output']>;
  b2b_order_id?: Maybe<Scalars['uuid']['output']>;
  code: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  current_balance: Scalars['bigint']['output'];
  customer_company?: Maybe<Customer_Company>;
  customer_company_id?: Maybe<Scalars['uuid']['output']>;
  dts_custom_field?: Maybe<Scalars['json']['output']>;
  dts_source?: Maybe<Scalars['String']['output']>;
  end_code?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  initial_balance: Scalars['bigint']['output'];
  pos_gift_card?: Maybe<Pos_Gift_Card>;
  pos_gift_card_id?: Maybe<Scalars['uuid']['output']>;
  price: Scalars['bigint']['output'];
  sold_date?: Maybe<Scalars['timestamptz']['output']>;
  start_code?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transactions: Array<Transaction>;
  transactions_aggregate: Transaction_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  whmcs_id?: Maybe<Scalars['Int']['output']>;
  whmcs_ids?: Maybe<Scalars['jsonb']['output']>;
};

export type Gift_CardDts_Custom_FieldArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Gift_CardTransactionsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

export type Gift_CardTransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

export type Gift_CardWhmcs_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Gift_Card_Aggregate = {
  aggregate?: Maybe<Gift_Card_Aggregate_Fields>;
  nodes: Array<Gift_Card>;
};

export type Gift_Card_Aggregate_Bool_Exp = {
  count?: InputMaybe<Gift_Card_Aggregate_Bool_Exp_Count>;
};

export type Gift_Card_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Gift_Card_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Gift_Card_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Gift_Card_Aggregate_Fields = {
  avg?: Maybe<Gift_Card_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Gift_Card_Max_Fields>;
  min?: Maybe<Gift_Card_Min_Fields>;
  stddev?: Maybe<Gift_Card_Stddev_Fields>;
  stddev_pop?: Maybe<Gift_Card_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gift_Card_Stddev_Samp_Fields>;
  sum?: Maybe<Gift_Card_Sum_Fields>;
  var_pop?: Maybe<Gift_Card_Var_Pop_Fields>;
  var_samp?: Maybe<Gift_Card_Var_Samp_Fields>;
  variance?: Maybe<Gift_Card_Variance_Fields>;
};

export type Gift_Card_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gift_Card_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Gift_Card_Aggregate_Order_By = {
  avg?: InputMaybe<Gift_Card_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gift_Card_Max_Order_By>;
  min?: InputMaybe<Gift_Card_Min_Order_By>;
  stddev?: InputMaybe<Gift_Card_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gift_Card_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gift_Card_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gift_Card_Sum_Order_By>;
  var_pop?: InputMaybe<Gift_Card_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gift_Card_Var_Samp_Order_By>;
  variance?: InputMaybe<Gift_Card_Variance_Order_By>;
};

export type Gift_Card_Avg_Fields = {
  current_balance?: Maybe<Scalars['Float']['output']>;
  initial_balance?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Avg_Order_By = {
  current_balance?: InputMaybe<Order_By>;
  initial_balance?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Gift_Card_Bool_Exp = {
  _and?: InputMaybe<Array<Gift_Card_Bool_Exp>>;
  _not?: InputMaybe<Gift_Card_Bool_Exp>;
  _or?: InputMaybe<Array<Gift_Card_Bool_Exp>>;
  b2b_gift_card_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  b2b_gift_card_template_no?: InputMaybe<String_Comparison_Exp>;
  b2b_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_balance?: InputMaybe<Bigint_Comparison_Exp>;
  customer_company?: InputMaybe<Customer_Company_Bool_Exp>;
  customer_company_id?: InputMaybe<Uuid_Comparison_Exp>;
  dts_custom_field?: InputMaybe<Json_Comparison_Exp>;
  dts_source?: InputMaybe<String_Comparison_Exp>;
  end_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initial_balance?: InputMaybe<Bigint_Comparison_Exp>;
  pos_gift_card?: InputMaybe<Pos_Gift_Card_Bool_Exp>;
  pos_gift_card_id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Bigint_Comparison_Exp>;
  sold_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  start_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  transactions?: InputMaybe<Transaction_Bool_Exp>;
  transactions_aggregate?: InputMaybe<Transaction_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  whmcs_id?: InputMaybe<Int_Comparison_Exp>;
  whmcs_ids?: InputMaybe<Jsonb_Comparison_Exp>;
};

export type Gift_Card_Check_Code_Input = {
  code: Scalars['String']['input'];
  whmcs_id: Scalars['Int']['input'];
};

export type Gift_Card_Create_Generate_Gift_Card_Request_Input = {
  b2b_order_id: Scalars['uuid']['input'];
};

export type Gift_Card_Create_Prefix_Gift_Card_Code_Input = {
  prefix_gift_card_code: Scalars['String']['input'];
  whmcs_id: Scalars['Int']['input'];
};

export type Gift_Card_Max_Fields = {
  b2b_gift_card_template_id?: Maybe<Scalars['uuid']['output']>;
  b2b_gift_card_template_no?: Maybe<Scalars['String']['output']>;
  b2b_order_id?: Maybe<Scalars['uuid']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_balance?: Maybe<Scalars['bigint']['output']>;
  customer_company_id?: Maybe<Scalars['uuid']['output']>;
  dts_source?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  initial_balance?: Maybe<Scalars['bigint']['output']>;
  pos_gift_card_id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  sold_date?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Gift_Card_Max_Order_By = {
  b2b_gift_card_template_id?: InputMaybe<Order_By>;
  b2b_gift_card_template_no?: InputMaybe<Order_By>;
  b2b_order_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_balance?: InputMaybe<Order_By>;
  customer_company_id?: InputMaybe<Order_By>;
  dts_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_balance?: InputMaybe<Order_By>;
  pos_gift_card_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sold_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Gift_Card_Min_Fields = {
  b2b_gift_card_template_id?: Maybe<Scalars['uuid']['output']>;
  b2b_gift_card_template_no?: Maybe<Scalars['String']['output']>;
  b2b_order_id?: Maybe<Scalars['uuid']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_balance?: Maybe<Scalars['bigint']['output']>;
  customer_company_id?: Maybe<Scalars['uuid']['output']>;
  dts_source?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  initial_balance?: Maybe<Scalars['bigint']['output']>;
  pos_gift_card_id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  sold_date?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Gift_Card_Min_Order_By = {
  b2b_gift_card_template_id?: InputMaybe<Order_By>;
  b2b_gift_card_template_no?: InputMaybe<Order_By>;
  b2b_order_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_balance?: InputMaybe<Order_By>;
  customer_company_id?: InputMaybe<Order_By>;
  dts_source?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_balance?: InputMaybe<Order_By>;
  pos_gift_card_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sold_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Gift_Card_Order_By = {
  b2b_gift_card_template_id?: InputMaybe<Order_By>;
  b2b_gift_card_template_no?: InputMaybe<Order_By>;
  b2b_order_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_balance?: InputMaybe<Order_By>;
  customer_company?: InputMaybe<Customer_Company_Order_By>;
  customer_company_id?: InputMaybe<Order_By>;
  dts_custom_field?: InputMaybe<Order_By>;
  dts_source?: InputMaybe<Order_By>;
  end_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_balance?: InputMaybe<Order_By>;
  pos_gift_card?: InputMaybe<Pos_Gift_Card_Order_By>;
  pos_gift_card_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  sold_date?: InputMaybe<Order_By>;
  start_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transactions_aggregate?: InputMaybe<Transaction_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
  whmcs_ids?: InputMaybe<Order_By>;
};

export type Gift_Card_Prefix_Code = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  prefix_code: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  whmcs_id: Scalars['Int']['output'];
};

export type Gift_Card_Prefix_Code_Aggregate = {
  aggregate?: Maybe<Gift_Card_Prefix_Code_Aggregate_Fields>;
  nodes: Array<Gift_Card_Prefix_Code>;
};

export type Gift_Card_Prefix_Code_Aggregate_Fields = {
  avg?: Maybe<Gift_Card_Prefix_Code_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Gift_Card_Prefix_Code_Max_Fields>;
  min?: Maybe<Gift_Card_Prefix_Code_Min_Fields>;
  stddev?: Maybe<Gift_Card_Prefix_Code_Stddev_Fields>;
  stddev_pop?: Maybe<Gift_Card_Prefix_Code_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gift_Card_Prefix_Code_Stddev_Samp_Fields>;
  sum?: Maybe<Gift_Card_Prefix_Code_Sum_Fields>;
  var_pop?: Maybe<Gift_Card_Prefix_Code_Var_Pop_Fields>;
  var_samp?: Maybe<Gift_Card_Prefix_Code_Var_Samp_Fields>;
  variance?: Maybe<Gift_Card_Prefix_Code_Variance_Fields>;
};

export type Gift_Card_Prefix_Code_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gift_Card_Prefix_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Gift_Card_Prefix_Code_Avg_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Prefix_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Gift_Card_Prefix_Code_Bool_Exp>>;
  _not?: InputMaybe<Gift_Card_Prefix_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Gift_Card_Prefix_Code_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  prefix_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  whmcs_id?: InputMaybe<Int_Comparison_Exp>;
};

export type Gift_Card_Prefix_Code_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  prefix_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Gift_Card_Prefix_Code_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  prefix_code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Gift_Card_Prefix_Code_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prefix_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export enum Gift_Card_Prefix_Code_Select_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  PrefixCode = 'prefix_code',
  Status = 'status',
  UpdatedAt = 'updated_at',
  WhmcsId = 'whmcs_id',
}

export type Gift_Card_Prefix_Code_Stddev_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Prefix_Code_Stddev_Pop_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Prefix_Code_Stddev_Samp_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Prefix_Code_Sum_Fields = {
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Gift_Card_Prefix_Code_Var_Pop_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Prefix_Code_Var_Samp_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Prefix_Code_Variance_Fields = {
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export enum Gift_Card_Select_Column {
  B2bGiftCardTemplateId = 'b2b_gift_card_template_id',
  B2bGiftCardTemplateNo = 'b2b_gift_card_template_no',
  B2bOrderId = 'b2b_order_id',
  Code = 'code',
  CreatedAt = 'created_at',
  CurrentBalance = 'current_balance',
  CustomerCompanyId = 'customer_company_id',
  DtsCustomField = 'dts_custom_field',
  DtsSource = 'dts_source',
  Id = 'id',
  InitialBalance = 'initial_balance',
  PosGiftCardId = 'pos_gift_card_id',
  Price = 'price',
  SoldDate = 'sold_date',
  Status = 'status',
  UpdatedAt = 'updated_at',
  WhmcsId = 'whmcs_id',
  WhmcsIds = 'whmcs_ids',
}

export type Gift_Card_Stddev_Fields = {
  current_balance?: Maybe<Scalars['Float']['output']>;
  initial_balance?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Stddev_Order_By = {
  current_balance?: InputMaybe<Order_By>;
  initial_balance?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Gift_Card_Stddev_Pop_Fields = {
  current_balance?: Maybe<Scalars['Float']['output']>;
  initial_balance?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Stddev_Pop_Order_By = {
  current_balance?: InputMaybe<Order_By>;
  initial_balance?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Gift_Card_Stddev_Samp_Fields = {
  current_balance?: Maybe<Scalars['Float']['output']>;
  initial_balance?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Stddev_Samp_Order_By = {
  current_balance?: InputMaybe<Order_By>;
  initial_balance?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Gift_Card_Sum_Fields = {
  current_balance?: Maybe<Scalars['bigint']['output']>;
  initial_balance?: Maybe<Scalars['bigint']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Gift_Card_Sum_Order_By = {
  current_balance?: InputMaybe<Order_By>;
  initial_balance?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Gift_Card_Var_Pop_Fields = {
  current_balance?: Maybe<Scalars['Float']['output']>;
  initial_balance?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Var_Pop_Order_By = {
  current_balance?: InputMaybe<Order_By>;
  initial_balance?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Gift_Card_Var_Samp_Fields = {
  current_balance?: Maybe<Scalars['Float']['output']>;
  initial_balance?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Var_Samp_Order_By = {
  current_balance?: InputMaybe<Order_By>;
  initial_balance?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Gift_Card_Variance_Fields = {
  current_balance?: Maybe<Scalars['Float']['output']>;
  initial_balance?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Gift_Card_Variance_Order_By = {
  current_balance?: InputMaybe<Order_By>;
  initial_balance?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Gql_Prefix_Code_Posted = {
  id: Scalars['String']['output'];
};

export type Gql_Transaction = {
  id: Scalars['String']['output'];
};

export type Graphql_Bamboo_Transaction = {
  card_type?: Maybe<Scalars['String']['output']>;
  gift_card_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Graphql_Bamboo_User = {
  time_zone?: Maybe<Scalars['String']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Graphql_Create_Gift_Card_Dts = {
  whmcs_id: Scalars['Int']['output'];
};

export type Graphql_Crm_Company = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  business_phone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
};

export type Graphql_Export_Gift_Card = {
  id?: Maybe<Scalars['String']['output']>;
};

export type Graphql_Generate_Gift_Card_Request = {
  id: Scalars['uuid']['output'];
};

export type Graphql_Get_Transaction_Detail = {
  balance_after?: Maybe<Scalars['Int']['output']>;
  balance_before?: Maybe<Scalars['Int']['output']>;
  balance_change?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Get_Transaction_Detail_Company>;
  date?: Maybe<Scalars['String']['output']>;
  gift_card?: Maybe<Get_Transaction_Detail_Gift_Card>;
  id?: Maybe<Scalars['String']['output']>;
  payment_methods: Array<Maybe<Get_Transaction_Detail_Payment_Method>>;
  price?: Maybe<Scalars['Int']['output']>;
  signature?: Maybe<Get_Transaction_Detail_Signature>;
  transaction_discount?: Maybe<Get_Transaction_Detail_Discount>;
  type?: Maybe<Scalars['String']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Graphql_Gift_Card = {
  id: Scalars['uuid']['output'];
};

export type Graphql_Gift_Card_Check_Code = {
  amount?: Maybe<Scalars['Int']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_balance?: Maybe<Scalars['Int']['output']>;
  initial_balance?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  transactions?: Maybe<Array<Graphql_Gift_Card_Check_Code_Transaction>>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Graphql_Gift_Card_Check_Code_Transaction = {
  balance_after?: Maybe<Scalars['Int']['output']>;
  balance_before?: Maybe<Scalars['Int']['output']>;
  balance_change?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dts_order_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Graphql_Transaction = {
  gift_card_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Graphql_User = {
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type Graphql_User_Login_Url = {
  path?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Import_Gift_Card_Request = {
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  gift_card_report?: Maybe<Storage_Object>;
  gift_card_report_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  num_of_gift_card: Scalars['Int']['output'];
  phone: Scalars['String']['output'];
  state: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  whmcs_id: Scalars['Int']['output'];
  zip_code: Scalars['String']['output'];
};

export type Import_Gift_Card_Request_Aggregate = {
  aggregate?: Maybe<Import_Gift_Card_Request_Aggregate_Fields>;
  nodes: Array<Import_Gift_Card_Request>;
};

export type Import_Gift_Card_Request_Aggregate_Fields = {
  avg?: Maybe<Import_Gift_Card_Request_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Import_Gift_Card_Request_Max_Fields>;
  min?: Maybe<Import_Gift_Card_Request_Min_Fields>;
  stddev?: Maybe<Import_Gift_Card_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Import_Gift_Card_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Import_Gift_Card_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Import_Gift_Card_Request_Sum_Fields>;
  var_pop?: Maybe<Import_Gift_Card_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Import_Gift_Card_Request_Var_Samp_Fields>;
  variance?: Maybe<Import_Gift_Card_Request_Variance_Fields>;
};

export type Import_Gift_Card_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Import_Gift_Card_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Import_Gift_Card_Request_Avg_Fields = {
  num_of_gift_card?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Import_Gift_Card_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Import_Gift_Card_Request_Bool_Exp>>;
  _not?: InputMaybe<Import_Gift_Card_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Import_Gift_Card_Request_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gift_card_report?: InputMaybe<Storage_Object_Bool_Exp>;
  gift_card_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  num_of_gift_card?: InputMaybe<Int_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  whmcs_id?: InputMaybe<Int_Comparison_Exp>;
  zip_code?: InputMaybe<String_Comparison_Exp>;
};

export type Import_Gift_Card_Request_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gift_card_report_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  num_of_gift_card?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type Import_Gift_Card_Request_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  gift_card_report_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  num_of_gift_card?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type Import_Gift_Card_Request_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gift_card_report?: InputMaybe<Storage_Object_Order_By>;
  gift_card_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  num_of_gift_card?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

export enum Import_Gift_Card_Request_Select_Column {
  Address = 'address',
  City = 'city',
  CreatedAt = 'created_at',
  GiftCardReportId = 'gift_card_report_id',
  Id = 'id',
  Name = 'name',
  NumOfGiftCard = 'num_of_gift_card',
  Phone = 'phone',
  State = 'state',
  Status = 'status',
  UpdatedAt = 'updated_at',
  WhmcsId = 'whmcs_id',
  ZipCode = 'zip_code',
}

export type Import_Gift_Card_Request_Stddev_Fields = {
  num_of_gift_card?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Import_Gift_Card_Request_Stddev_Pop_Fields = {
  num_of_gift_card?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Import_Gift_Card_Request_Stddev_Samp_Fields = {
  num_of_gift_card?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Import_Gift_Card_Request_Sum_Fields = {
  num_of_gift_card?: Maybe<Scalars['Int']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Import_Gift_Card_Request_Var_Pop_Fields = {
  num_of_gift_card?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Import_Gift_Card_Request_Var_Samp_Fields = {
  num_of_gift_card?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Import_Gift_Card_Request_Variance_Fields = {
  num_of_gift_card?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  _has_key?: InputMaybe<Scalars['String']['input']>;
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export enum Order_By {
  Asc = 'asc',
  AscNullsFirst = 'asc_nulls_first',
  AscNullsLast = 'asc_nulls_last',
  Desc = 'desc',
  DescNullsFirst = 'desc_nulls_first',
  DescNullsLast = 'desc_nulls_last',
}

export type Payment_Method = {
  action?: Maybe<Scalars['String']['output']>;
  auth_code?: Maybe<Scalars['String']['output']>;
  card_info?: Maybe<Card_Info>;
  card_info_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  date: Scalars['timestamptz']['output'];
  device_id?: Maybe<Scalars['uuid']['output']>;
  device_sn?: Maybe<Scalars['String']['output']>;
  gci_payment_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  price: Scalars['bigint']['output'];
  reference_id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  trans_message?: Maybe<Scalars['String']['output']>;
  transaction?: Maybe<Transaction>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

export type Payment_Method_Aggregate = {
  aggregate?: Maybe<Payment_Method_Aggregate_Fields>;
  nodes: Array<Payment_Method>;
};

export type Payment_Method_Aggregate_Bool_Exp = {
  count?: InputMaybe<Payment_Method_Aggregate_Bool_Exp_Count>;
};

export type Payment_Method_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payment_Method_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Payment_Method_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Payment_Method_Aggregate_Fields = {
  avg?: Maybe<Payment_Method_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Payment_Method_Max_Fields>;
  min?: Maybe<Payment_Method_Min_Fields>;
  stddev?: Maybe<Payment_Method_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Method_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Method_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Method_Sum_Fields>;
  var_pop?: Maybe<Payment_Method_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Method_Var_Samp_Fields>;
  variance?: Maybe<Payment_Method_Variance_Fields>;
};

export type Payment_Method_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Method_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Payment_Method_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Method_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Method_Max_Order_By>;
  min?: InputMaybe<Payment_Method_Min_Order_By>;
  stddev?: InputMaybe<Payment_Method_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Method_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Method_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Method_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Method_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Method_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Method_Variance_Order_By>;
};

export type Payment_Method_Avg_Fields = {
  price?: Maybe<Scalars['Float']['output']>;
};

export type Payment_Method_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
};

export type Payment_Method_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Method_Bool_Exp>>;
  _not?: InputMaybe<Payment_Method_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Method_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  auth_code?: InputMaybe<String_Comparison_Exp>;
  card_info?: InputMaybe<Card_Info_Bool_Exp>;
  card_info_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_id?: InputMaybe<Uuid_Comparison_Exp>;
  device_sn?: InputMaybe<String_Comparison_Exp>;
  gci_payment_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Bigint_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trans_message?: InputMaybe<String_Comparison_Exp>;
  transaction?: InputMaybe<Transaction_Bool_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

export type Payment_Method_Max_Fields = {
  action?: Maybe<Scalars['String']['output']>;
  auth_code?: Maybe<Scalars['String']['output']>;
  card_info_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  device_id?: Maybe<Scalars['uuid']['output']>;
  device_sn?: Maybe<Scalars['String']['output']>;
  gci_payment_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  reference_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trans_message?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

export type Payment_Method_Max_Order_By = {
  action?: InputMaybe<Order_By>;
  auth_code?: InputMaybe<Order_By>;
  card_info_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_sn?: InputMaybe<Order_By>;
  gci_payment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trans_message?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

export type Payment_Method_Min_Fields = {
  action?: Maybe<Scalars['String']['output']>;
  auth_code?: Maybe<Scalars['String']['output']>;
  card_info_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  device_id?: Maybe<Scalars['uuid']['output']>;
  device_sn?: Maybe<Scalars['String']['output']>;
  gci_payment_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  reference_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trans_message?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

export type Payment_Method_Min_Order_By = {
  action?: InputMaybe<Order_By>;
  auth_code?: InputMaybe<Order_By>;
  card_info_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_sn?: InputMaybe<Order_By>;
  gci_payment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trans_message?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

export type Payment_Method_Order_By = {
  action?: InputMaybe<Order_By>;
  auth_code?: InputMaybe<Order_By>;
  card_info?: InputMaybe<Card_Info_Order_By>;
  card_info_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_sn?: InputMaybe<Order_By>;
  gci_payment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trans_message?: InputMaybe<Order_By>;
  transaction?: InputMaybe<Transaction_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

export enum Payment_Method_Select_Column {
  Action = 'action',
  AuthCode = 'auth_code',
  CardInfoId = 'card_info_id',
  CreatedAt = 'created_at',
  Date = 'date',
  DeviceId = 'device_id',
  DeviceSn = 'device_sn',
  GciPaymentId = 'gci_payment_id',
  Id = 'id',
  Price = 'price',
  ReferenceId = 'reference_id',
  Status = 'status',
  TransMessage = 'trans_message',
  TransactionId = 'transaction_id',
  Type = 'type',
  UpdatedAt = 'updated_at',
}

export type Payment_Method_Stddev_Fields = {
  price?: Maybe<Scalars['Float']['output']>;
};

export type Payment_Method_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
};

export type Payment_Method_Stddev_Pop_Fields = {
  price?: Maybe<Scalars['Float']['output']>;
};

export type Payment_Method_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
};

export type Payment_Method_Stddev_Samp_Fields = {
  price?: Maybe<Scalars['Float']['output']>;
};

export type Payment_Method_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
};

export type Payment_Method_Sum_Fields = {
  price?: Maybe<Scalars['bigint']['output']>;
};

export type Payment_Method_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
};

export type Payment_Method_Var_Pop_Fields = {
  price?: Maybe<Scalars['Float']['output']>;
};

export type Payment_Method_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
};

export type Payment_Method_Var_Samp_Fields = {
  price?: Maybe<Scalars['Float']['output']>;
};

export type Payment_Method_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
};

export type Payment_Method_Variance_Fields = {
  price?: Maybe<Scalars['Float']['output']>;
};

export type Payment_Method_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
};

export type Pos_Gift_Card = {
  code: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  end_code?: Maybe<Scalars['String']['output']>;
  gift_card?: Maybe<Gift_Card>;
  id: Scalars['uuid']['output'];
  start_code?: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  whmcs_id: Scalars['Int']['output'];
};

export type Pos_Gift_Card_Aggregate = {
  aggregate?: Maybe<Pos_Gift_Card_Aggregate_Fields>;
  nodes: Array<Pos_Gift_Card>;
};

export type Pos_Gift_Card_Aggregate_Fields = {
  avg?: Maybe<Pos_Gift_Card_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pos_Gift_Card_Max_Fields>;
  min?: Maybe<Pos_Gift_Card_Min_Fields>;
  stddev?: Maybe<Pos_Gift_Card_Stddev_Fields>;
  stddev_pop?: Maybe<Pos_Gift_Card_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pos_Gift_Card_Stddev_Samp_Fields>;
  sum?: Maybe<Pos_Gift_Card_Sum_Fields>;
  var_pop?: Maybe<Pos_Gift_Card_Var_Pop_Fields>;
  var_samp?: Maybe<Pos_Gift_Card_Var_Samp_Fields>;
  variance?: Maybe<Pos_Gift_Card_Variance_Fields>;
};

export type Pos_Gift_Card_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pos_Gift_Card_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Pos_Gift_Card_Avg_Fields = {
  status?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Pos_Gift_Card_Bool_Exp = {
  _and?: InputMaybe<Array<Pos_Gift_Card_Bool_Exp>>;
  _not?: InputMaybe<Pos_Gift_Card_Bool_Exp>;
  _or?: InputMaybe<Array<Pos_Gift_Card_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_code?: InputMaybe<String_Comparison_Exp>;
  gift_card?: InputMaybe<Gift_Card_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  start_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  whmcs_id?: InputMaybe<Int_Comparison_Exp>;
};

export type Pos_Gift_Card_Max_Fields = {
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Pos_Gift_Card_Min_Fields = {
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Pos_Gift_Card_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_code?: InputMaybe<Order_By>;
  gift_card?: InputMaybe<Gift_Card_Order_By>;
  id?: InputMaybe<Order_By>;
  start_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export enum Pos_Gift_Card_Select_Column {
  Code = 'code',
  CreatedAt = 'created_at',
  Id = 'id',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updated_at',
  WhmcsId = 'whmcs_id',
}

export type Pos_Gift_Card_Stddev_Fields = {
  status?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Pos_Gift_Card_Stddev_Pop_Fields = {
  status?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Pos_Gift_Card_Stddev_Samp_Fields = {
  status?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Pos_Gift_Card_Sum_Fields = {
  status?: Maybe<Scalars['Int']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Pos_Gift_Card_Var_Pop_Fields = {
  status?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Pos_Gift_Card_Var_Samp_Fields = {
  status?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Pos_Gift_Card_Variance_Fields = {
  status?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

export type Storage_Object = {
  base_uri?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  mime_type: Scalars['String']['output'];
  name: Scalars['String']['output'];
  original_name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  uploaded_by?: Maybe<Scalars['String']['output']>;
};

export type Storage_Object_Aggregate = {
  aggregate?: Maybe<Storage_Object_Aggregate_Fields>;
  nodes: Array<Storage_Object>;
};

export type Storage_Object_Aggregate_Fields = {
  avg?: Maybe<Storage_Object_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Storage_Object_Max_Fields>;
  min?: Maybe<Storage_Object_Min_Fields>;
  stddev?: Maybe<Storage_Object_Stddev_Fields>;
  stddev_pop?: Maybe<Storage_Object_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Storage_Object_Stddev_Samp_Fields>;
  sum?: Maybe<Storage_Object_Sum_Fields>;
  var_pop?: Maybe<Storage_Object_Var_Pop_Fields>;
  var_samp?: Maybe<Storage_Object_Var_Samp_Fields>;
  variance?: Maybe<Storage_Object_Variance_Fields>;
};

export type Storage_Object_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Storage_Object_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Storage_Object_Avg_Fields = {
  size?: Maybe<Scalars['Float']['output']>;
};

export type Storage_Object_Bool_Exp = {
  _and?: InputMaybe<Array<Storage_Object_Bool_Exp>>;
  _not?: InputMaybe<Storage_Object_Bool_Exp>;
  _or?: InputMaybe<Array<Storage_Object_Bool_Exp>>;
  base_uri?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mime_type?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  original_name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploaded_by?: InputMaybe<String_Comparison_Exp>;
};

export type Storage_Object_Max_Fields = {
  base_uri?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uploaded_by?: Maybe<Scalars['String']['output']>;
};

export type Storage_Object_Min_Fields = {
  base_uri?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  uploaded_by?: Maybe<Scalars['String']['output']>;
};

export type Storage_Object_Order_By = {
  base_uri?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  original_name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploaded_by?: InputMaybe<Order_By>;
};

export enum Storage_Object_Select_Column {
  BaseUri = 'base_uri',
  CreatedAt = 'created_at',
  Id = 'id',
  MimeType = 'mime_type',
  Name = 'name',
  OriginalName = 'original_name',
  Size = 'size',
  UpdatedAt = 'updated_at',
  UploadedBy = 'uploaded_by',
}

export type Storage_Object_Stddev_Fields = {
  size?: Maybe<Scalars['Float']['output']>;
};

export type Storage_Object_Stddev_Pop_Fields = {
  size?: Maybe<Scalars['Float']['output']>;
};

export type Storage_Object_Stddev_Samp_Fields = {
  size?: Maybe<Scalars['Float']['output']>;
};

export type Storage_Object_Sum_Fields = {
  size?: Maybe<Scalars['Int']['output']>;
};

export type Storage_Object_Var_Pop_Fields = {
  size?: Maybe<Scalars['Float']['output']>;
};

export type Storage_Object_Var_Samp_Fields = {
  size?: Maybe<Scalars['Float']['output']>;
};

export type Storage_Object_Variance_Fields = {
  size?: Maybe<Scalars['Float']['output']>;
};

export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export type Transaction = {
  balance_after: Scalars['bigint']['output'];
  balance_before: Scalars['bigint']['output'];
  balance_change: Scalars['bigint']['output'];
  code: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  date: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dts_custom_field?: Maybe<Scalars['json']['output']>;
  dts_order_id?: Maybe<Scalars['Int']['output']>;
  gift_card?: Maybe<Gift_Card>;
  gift_card_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_skip_update_balance?: Maybe<Scalars['Boolean']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  payment_methods: Array<Payment_Method>;
  payment_methods_aggregate: Payment_Method_Aggregate;
  pos_gift_card_history_id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Storage_Object>;
  signature_id?: Maybe<Scalars['uuid']['output']>;
  transaction?: Maybe<Transaction>;
  transaction_discount?: Maybe<Transaction_Discount>;
  transaction_discounts: Array<Transaction_Discount>;
  transaction_discounts_aggregate: Transaction_Discount_Aggregate;
  transaction_reverted_id?: Maybe<Scalars['uuid']['output']>;
  transactions: Array<Transaction>;
  transactions_aggregate: Transaction_Aggregate;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  whmcs_id: Scalars['Int']['output'];
};

export type TransactionDts_Custom_FieldArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};

export type TransactionPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};

export type TransactionTransaction_DiscountsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Discount_Order_By>>;
  where?: InputMaybe<Transaction_Discount_Bool_Exp>;
};

export type TransactionTransaction_Discounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Discount_Order_By>>;
  where?: InputMaybe<Transaction_Discount_Bool_Exp>;
};

export type TransactionTransactionsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

export type TransactionTransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

export type Transaction_Aggregate = {
  aggregate?: Maybe<Transaction_Aggregate_Fields>;
  nodes: Array<Transaction>;
};

export type Transaction_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Transaction_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Transaction_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Transaction_Aggregate_Bool_Exp_Count>;
};

export type Transaction_Aggregate_Bool_Exp_Bool_And = {
  arguments: Transaction_Select_Column_Transaction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transaction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Transaction_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Transaction_Select_Column_Transaction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transaction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Transaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Transaction_Aggregate_Fields = {
  avg?: Maybe<Transaction_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Transaction_Max_Fields>;
  min?: Maybe<Transaction_Min_Fields>;
  stddev?: Maybe<Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Transaction_Sum_Fields>;
  var_pop?: Maybe<Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Transaction_Var_Samp_Fields>;
  variance?: Maybe<Transaction_Variance_Fields>;
};

export type Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transaction_Max_Order_By>;
  min?: InputMaybe<Transaction_Min_Order_By>;
  stddev?: InputMaybe<Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Transaction_Variance_Order_By>;
};

export type Transaction_Avg_Fields = {
  balance_after?: Maybe<Scalars['Float']['output']>;
  balance_before?: Maybe<Scalars['Float']['output']>;
  balance_change?: Maybe<Scalars['Float']['output']>;
  dts_order_id?: Maybe<Scalars['Float']['output']>;
  pos_gift_card_history_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Avg_Order_By = {
  balance_after?: InputMaybe<Order_By>;
  balance_before?: InputMaybe<Order_By>;
  balance_change?: InputMaybe<Order_By>;
  dts_order_id?: InputMaybe<Order_By>;
  pos_gift_card_history_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Bool_Exp>>;
  balance_after?: InputMaybe<Bigint_Comparison_Exp>;
  balance_before?: InputMaybe<Bigint_Comparison_Exp>;
  balance_change?: InputMaybe<Bigint_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dts_custom_field?: InputMaybe<Json_Comparison_Exp>;
  dts_order_id?: InputMaybe<Int_Comparison_Exp>;
  gift_card?: InputMaybe<Gift_Card_Bool_Exp>;
  gift_card_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_skip_update_balance?: InputMaybe<Boolean_Comparison_Exp>;
  order_id?: InputMaybe<String_Comparison_Exp>;
  payment_methods?: InputMaybe<Payment_Method_Bool_Exp>;
  payment_methods_aggregate?: InputMaybe<Payment_Method_Aggregate_Bool_Exp>;
  pos_gift_card_history_id?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Bigint_Comparison_Exp>;
  service?: InputMaybe<String_Comparison_Exp>;
  signature?: InputMaybe<Storage_Object_Bool_Exp>;
  signature_id?: InputMaybe<Uuid_Comparison_Exp>;
  transaction?: InputMaybe<Transaction_Bool_Exp>;
  transaction_discount?: InputMaybe<Transaction_Discount_Bool_Exp>;
  transaction_discounts?: InputMaybe<Transaction_Discount_Bool_Exp>;
  transaction_discounts_aggregate?: InputMaybe<Transaction_Discount_Aggregate_Bool_Exp>;
  transaction_reverted_id?: InputMaybe<Uuid_Comparison_Exp>;
  transactions?: InputMaybe<Transaction_Bool_Exp>;
  transactions_aggregate?: InputMaybe<Transaction_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  whmcs_id?: InputMaybe<Int_Comparison_Exp>;
};

export type Transaction_Discount = {
  created_at: Scalars['timestamptz']['output'];
  discount_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  transaction?: Maybe<Transaction>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  value: Scalars['Int']['output'];
};

export type Transaction_Discount_Aggregate = {
  aggregate?: Maybe<Transaction_Discount_Aggregate_Fields>;
  nodes: Array<Transaction_Discount>;
};

export type Transaction_Discount_Aggregate_Bool_Exp = {
  count?: InputMaybe<Transaction_Discount_Aggregate_Bool_Exp_Count>;
};

export type Transaction_Discount_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Transaction_Discount_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transaction_Discount_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Transaction_Discount_Aggregate_Fields = {
  avg?: Maybe<Transaction_Discount_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Transaction_Discount_Max_Fields>;
  min?: Maybe<Transaction_Discount_Min_Fields>;
  stddev?: Maybe<Transaction_Discount_Stddev_Fields>;
  stddev_pop?: Maybe<Transaction_Discount_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transaction_Discount_Stddev_Samp_Fields>;
  sum?: Maybe<Transaction_Discount_Sum_Fields>;
  var_pop?: Maybe<Transaction_Discount_Var_Pop_Fields>;
  var_samp?: Maybe<Transaction_Discount_Var_Samp_Fields>;
  variance?: Maybe<Transaction_Discount_Variance_Fields>;
};

export type Transaction_Discount_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Discount_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Transaction_Discount_Aggregate_Order_By = {
  avg?: InputMaybe<Transaction_Discount_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transaction_Discount_Max_Order_By>;
  min?: InputMaybe<Transaction_Discount_Min_Order_By>;
  stddev?: InputMaybe<Transaction_Discount_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transaction_Discount_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transaction_Discount_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transaction_Discount_Sum_Order_By>;
  var_pop?: InputMaybe<Transaction_Discount_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transaction_Discount_Var_Samp_Order_By>;
  variance?: InputMaybe<Transaction_Discount_Variance_Order_By>;
};

export type Transaction_Discount_Avg_Fields = {
  value?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Discount_Avg_Order_By = {
  value?: InputMaybe<Order_By>;
};

export type Transaction_Discount_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Discount_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Discount_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Discount_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discount_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  transaction?: InputMaybe<Transaction_Bool_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

export type Transaction_Discount_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  discount_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type Transaction_Discount_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  discount_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

export type Transaction_Discount_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  discount_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type Transaction_Discount_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  discount_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

export type Transaction_Discount_Order_By = {
  created_at?: InputMaybe<Order_By>;
  discount_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction?: InputMaybe<Transaction_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

export enum Transaction_Discount_Select_Column {
  CreatedAt = 'created_at',
  DiscountType = 'discount_type',
  Id = 'id',
  TransactionId = 'transaction_id',
  UpdatedAt = 'updated_at',
  Value = 'value',
}

export type Transaction_Discount_Stddev_Fields = {
  value?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Discount_Stddev_Order_By = {
  value?: InputMaybe<Order_By>;
};

export type Transaction_Discount_Stddev_Pop_Fields = {
  value?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Discount_Stddev_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

export type Transaction_Discount_Stddev_Samp_Fields = {
  value?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Discount_Stddev_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

export type Transaction_Discount_Sum_Fields = {
  value?: Maybe<Scalars['Int']['output']>;
};

export type Transaction_Discount_Sum_Order_By = {
  value?: InputMaybe<Order_By>;
};

export type Transaction_Discount_Var_Pop_Fields = {
  value?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Discount_Var_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

export type Transaction_Discount_Var_Samp_Fields = {
  value?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Discount_Var_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

export type Transaction_Discount_Variance_Fields = {
  value?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Discount_Variance_Order_By = {
  value?: InputMaybe<Order_By>;
};

export type Transaction_Max_Fields = {
  balance_after?: Maybe<Scalars['bigint']['output']>;
  balance_before?: Maybe<Scalars['bigint']['output']>;
  balance_change?: Maybe<Scalars['bigint']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dts_order_id?: Maybe<Scalars['Int']['output']>;
  gift_card_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pos_gift_card_history_id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  signature_id?: Maybe<Scalars['uuid']['output']>;
  transaction_reverted_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Transaction_Max_Order_By = {
  balance_after?: InputMaybe<Order_By>;
  balance_before?: InputMaybe<Order_By>;
  balance_change?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dts_order_id?: InputMaybe<Order_By>;
  gift_card_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pos_gift_card_history_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  signature_id?: InputMaybe<Order_By>;
  transaction_reverted_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Transaction_Min_Fields = {
  balance_after?: Maybe<Scalars['bigint']['output']>;
  balance_before?: Maybe<Scalars['bigint']['output']>;
  balance_change?: Maybe<Scalars['bigint']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dts_order_id?: Maybe<Scalars['Int']['output']>;
  gift_card_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pos_gift_card_history_id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  signature_id?: Maybe<Scalars['uuid']['output']>;
  transaction_reverted_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Transaction_Min_Order_By = {
  balance_after?: InputMaybe<Order_By>;
  balance_before?: InputMaybe<Order_By>;
  balance_change?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dts_order_id?: InputMaybe<Order_By>;
  gift_card_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pos_gift_card_history_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  signature_id?: InputMaybe<Order_By>;
  transaction_reverted_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Transaction_Order_By = {
  balance_after?: InputMaybe<Order_By>;
  balance_before?: InputMaybe<Order_By>;
  balance_change?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dts_custom_field?: InputMaybe<Order_By>;
  dts_order_id?: InputMaybe<Order_By>;
  gift_card?: InputMaybe<Gift_Card_Order_By>;
  gift_card_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_skip_update_balance?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_methods_aggregate?: InputMaybe<Payment_Method_Aggregate_Order_By>;
  pos_gift_card_history_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  signature?: InputMaybe<Storage_Object_Order_By>;
  signature_id?: InputMaybe<Order_By>;
  transaction?: InputMaybe<Transaction_Order_By>;
  transaction_discount?: InputMaybe<Transaction_Discount_Order_By>;
  transaction_discounts_aggregate?: InputMaybe<Transaction_Discount_Aggregate_Order_By>;
  transaction_reverted_id?: InputMaybe<Order_By>;
  transactions_aggregate?: InputMaybe<Transaction_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export enum Transaction_Select_Column {
  BalanceAfter = 'balance_after',
  BalanceBefore = 'balance_before',
  BalanceChange = 'balance_change',
  Code = 'code',
  CreatedAt = 'created_at',
  Date = 'date',
  DeletedAt = 'deleted_at',
  Description = 'description',
  DtsCustomField = 'dts_custom_field',
  DtsOrderId = 'dts_order_id',
  GiftCardId = 'gift_card_id',
  Id = 'id',
  IsSkipUpdateBalance = 'is_skip_update_balance',
  PosGiftCardHistoryId = 'pos_gift_card_history_id',
  Price = 'price',
  Service = 'service',
  SignatureId = 'signature_id',
  TransactionRevertedId = 'transaction_reverted_id',
  Type = 'type',
  UpdatedAt = 'updated_at',
  WhmcsId = 'whmcs_id',
}

export enum Transaction_Select_Column_Transaction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  IsSkipUpdateBalance = 'is_skip_update_balance',
}

export enum Transaction_Select_Column_Transaction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  IsSkipUpdateBalance = 'is_skip_update_balance',
}

export type Transaction_Stddev_Fields = {
  balance_after?: Maybe<Scalars['Float']['output']>;
  balance_before?: Maybe<Scalars['Float']['output']>;
  balance_change?: Maybe<Scalars['Float']['output']>;
  dts_order_id?: Maybe<Scalars['Float']['output']>;
  pos_gift_card_history_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Stddev_Order_By = {
  balance_after?: InputMaybe<Order_By>;
  balance_before?: InputMaybe<Order_By>;
  balance_change?: InputMaybe<Order_By>;
  dts_order_id?: InputMaybe<Order_By>;
  pos_gift_card_history_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Transaction_Stddev_Pop_Fields = {
  balance_after?: Maybe<Scalars['Float']['output']>;
  balance_before?: Maybe<Scalars['Float']['output']>;
  balance_change?: Maybe<Scalars['Float']['output']>;
  dts_order_id?: Maybe<Scalars['Float']['output']>;
  pos_gift_card_history_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Stddev_Pop_Order_By = {
  balance_after?: InputMaybe<Order_By>;
  balance_before?: InputMaybe<Order_By>;
  balance_change?: InputMaybe<Order_By>;
  dts_order_id?: InputMaybe<Order_By>;
  pos_gift_card_history_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Transaction_Stddev_Samp_Fields = {
  balance_after?: Maybe<Scalars['Float']['output']>;
  balance_before?: Maybe<Scalars['Float']['output']>;
  balance_change?: Maybe<Scalars['Float']['output']>;
  dts_order_id?: Maybe<Scalars['Float']['output']>;
  pos_gift_card_history_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Stddev_Samp_Order_By = {
  balance_after?: InputMaybe<Order_By>;
  balance_before?: InputMaybe<Order_By>;
  balance_change?: InputMaybe<Order_By>;
  dts_order_id?: InputMaybe<Order_By>;
  pos_gift_card_history_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Transaction_Sum_Fields = {
  balance_after?: Maybe<Scalars['bigint']['output']>;
  balance_before?: Maybe<Scalars['bigint']['output']>;
  balance_change?: Maybe<Scalars['bigint']['output']>;
  dts_order_id?: Maybe<Scalars['Int']['output']>;
  pos_gift_card_history_id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  whmcs_id?: Maybe<Scalars['Int']['output']>;
};

export type Transaction_Sum_Order_By = {
  balance_after?: InputMaybe<Order_By>;
  balance_before?: InputMaybe<Order_By>;
  balance_change?: InputMaybe<Order_By>;
  dts_order_id?: InputMaybe<Order_By>;
  pos_gift_card_history_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Transaction_Var_Pop_Fields = {
  balance_after?: Maybe<Scalars['Float']['output']>;
  balance_before?: Maybe<Scalars['Float']['output']>;
  balance_change?: Maybe<Scalars['Float']['output']>;
  dts_order_id?: Maybe<Scalars['Float']['output']>;
  pos_gift_card_history_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Var_Pop_Order_By = {
  balance_after?: InputMaybe<Order_By>;
  balance_before?: InputMaybe<Order_By>;
  balance_change?: InputMaybe<Order_By>;
  dts_order_id?: InputMaybe<Order_By>;
  pos_gift_card_history_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Transaction_Var_Samp_Fields = {
  balance_after?: Maybe<Scalars['Float']['output']>;
  balance_before?: Maybe<Scalars['Float']['output']>;
  balance_change?: Maybe<Scalars['Float']['output']>;
  dts_order_id?: Maybe<Scalars['Float']['output']>;
  pos_gift_card_history_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Var_Samp_Order_By = {
  balance_after?: InputMaybe<Order_By>;
  balance_before?: InputMaybe<Order_By>;
  balance_change?: InputMaybe<Order_By>;
  dts_order_id?: InputMaybe<Order_By>;
  pos_gift_card_history_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Transaction_Variance_Fields = {
  balance_after?: Maybe<Scalars['Float']['output']>;
  balance_before?: Maybe<Scalars['Float']['output']>;
  balance_change?: Maybe<Scalars['Float']['output']>;
  dts_order_id?: Maybe<Scalars['Float']['output']>;
  pos_gift_card_history_id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  whmcs_id?: Maybe<Scalars['Float']['output']>;
};

export type Transaction_Variance_Order_By = {
  balance_after?: InputMaybe<Order_By>;
  balance_before?: InputMaybe<Order_By>;
  balance_change?: InputMaybe<Order_By>;
  dts_order_id?: InputMaybe<Order_By>;
  pos_gift_card_history_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  whmcs_id?: InputMaybe<Order_By>;
};

export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type Valor_Create_Transaction_Input = {
  balance_change: Scalars['Int']['input'];
  date: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  gift_card_id: Scalars['uuid']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  whmcs_id: Scalars['Int']['input'];
};

export type BambooUserGetInfoFragment = {
  whmcs_id?: number | null;
  time_zone?: string | null;
};

export type BambooUserGetInfoQueryVariables = Exact<{ [key: string]: never }>;

export type BambooUserGetInfoQuery = {
  bamboo_user_get_info?: {
    whmcs_id?: number | null;
    time_zone?: string | null;
  } | null;
};

export type GiftCardTransactionFragment = {
  dts_order_id?: number | null;
  balance_after?: number | null;
  balance_before?: number | null;
  balance_change?: number | null;
  type?: string | null;
  date?: string | null;
};

export type GiftCardCheckCodeFragment = {
  company_name?: string | null;
  whmcs_id?: number | null;
  created_at?: string | null;
  current_balance?: number | null;
  initial_balance?: number | null;
  amount?: number | null;
  price?: number | null;
  transactions?: Array<{
    dts_order_id?: number | null;
    balance_after?: number | null;
    balance_before?: number | null;
    balance_change?: number | null;
    type?: string | null;
    date?: string | null;
  }> | null;
};

export type GiftCardCheckCodeQueryVariables = Exact<{
  input_obj: Gift_Card_Check_Code_Input;
}>;

export type GiftCardCheckCodeQuery = {
  gift_card_check_code?: {
    company_name?: string | null;
    whmcs_id?: number | null;
    created_at?: string | null;
    current_balance?: number | null;
    initial_balance?: number | null;
    amount?: number | null;
    price?: number | null;
    transactions?: Array<{
      dts_order_id?: number | null;
      balance_after?: number | null;
      balance_before?: number | null;
      balance_change?: number | null;
      type?: string | null;
      date?: string | null;
    }> | null;
  } | null;
};

export type CrmCompanyQueryVariables = Exact<{
  input_obj: Crm_Company_Input;
}>;

export type CrmCompanyQuery = {
  crm_company?: {
    name?: string | null;
    address1?: string | null;
    business_phone?: string | null;
    time_zone?: string | null;
  } | null;
};

export type GiftCardTransactionsFragment = {
  id: string;
  code: string;
  price?: any | null;
  type: string;
  date: string;
  balance_change: any;
  balance_after: any;
  balance_before: any;
  whmcs_id: number;
  signature?: { base_uri?: string | null; name: string } | null;
  gift_card?: {
    code: string;
    customer_company?: {
      name: string;
      customer?: { phone_number: string } | null;
    } | null;
    pos_gift_card?: { code: string; id: string } | null;
  } | null;
  transaction_discount?: { value: number } | null;
  payment_methods: Array<{
    type: string;
    id: string;
    action?: string | null;
    auth_code?: string | null;
    device_id?: string | null;
    device_sn?: string | null;
    trans_message?: string | null;
    reference_id: string;
    card_info?: {
      card_number_first_six?: string | null;
      card_number_last_four?: string | null;
      cardholder_name?: string | null;
      card_type?: string | null;
      expiration_date?: string | null;
    } | null;
  }>;
};

export type GiftCardTransactionListQueryVariables = Exact<{
  where?: InputMaybe<Transaction_Bool_Exp>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Transaction_Order_By> | Transaction_Order_By>;
}>;

export type GiftCardTransactionListQuery = {
  transaction: Array<{
    id: string;
    code: string;
    price?: any | null;
    type: string;
    date: string;
    balance_change: any;
    balance_after: any;
    balance_before: any;
    whmcs_id: number;
    signature?: { base_uri?: string | null; name: string } | null;
    gift_card?: {
      code: string;
      customer_company?: {
        name: string;
        customer?: { phone_number: string } | null;
      } | null;
      pos_gift_card?: { code: string; id: string } | null;
    } | null;
    transaction_discount?: { value: number } | null;
    payment_methods: Array<{
      type: string;
      id: string;
      action?: string | null;
      auth_code?: string | null;
      device_id?: string | null;
      device_sn?: string | null;
      trans_message?: string | null;
      reference_id: string;
      card_info?: {
        card_number_first_six?: string | null;
        card_number_last_four?: string | null;
        cardholder_name?: string | null;
        card_type?: string | null;
        expiration_date?: string | null;
      } | null;
    }>;
  }>;
};

export type GiftCardTransactionByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;

export type GiftCardTransactionByPkQuery = {
  transaction_by_pk?: {
    id: string;
    code: string;
    price?: any | null;
    type: string;
    date: string;
    balance_change: any;
    balance_after: any;
    balance_before: any;
    whmcs_id: number;
    signature?: { base_uri?: string | null; name: string } | null;
    gift_card?: {
      code: string;
      customer_company?: {
        name: string;
        customer?: { phone_number: string } | null;
      } | null;
      pos_gift_card?: { code: string; id: string } | null;
    } | null;
    transaction_discount?: { value: number } | null;
    payment_methods: Array<{
      type: string;
      id: string;
      action?: string | null;
      auth_code?: string | null;
      device_id?: string | null;
      device_sn?: string | null;
      trans_message?: string | null;
      reference_id: string;
      card_info?: {
        card_number_first_six?: string | null;
        card_number_last_four?: string | null;
        cardholder_name?: string | null;
        card_type?: string | null;
        expiration_date?: string | null;
      } | null;
    }>;
  } | null;
};

export type TotalGiftCardSoldQueryVariables = Exact<{
  where?: InputMaybe<Gift_Card_Bool_Exp>;
}>;

export type TotalGiftCardSoldQuery = {
  gift_card_aggregate: { aggregate?: { count: number } | null };
};

export type TotalGiftCardQueryVariables = Exact<{
  where?: InputMaybe<Transaction_Bool_Exp>;
}>;

export type TotalGiftCardQuery = {
  transaction_aggregate: {
    aggregate?: { sum?: { balance_change?: any | null } | null } | null;
  };
};

export type GiftCardInformationFragment = {
  id: string;
  current_balance: any;
  status: string;
  transactions: Array<{
    type: string;
    date: string;
    balance_change: any;
    balance_before: any;
    order_id?: string | null;
    dts_order_id?: number | null;
  }>;
};

export type TransactionDetailFragment = {
  balance_after?: number | null;
  balance_before?: number | null;
  balance_change?: number | null;
  code?: string | null;
  date?: string | null;
  id?: string | null;
  price?: number | null;
  type?: string | null;
  whmcs_id?: number | null;
  company?: {
    name?: string | null;
    address1?: string | null;
    address2?: string | null;
    business_phone?: string | null;
  } | null;
  gift_card?: {
    code?: string | null;
    pos_gift_card?: { code?: string | null; id?: string | null } | null;
  } | null;
  payment_methods: Array<{
    action?: string | null;
    auth_code?: string | null;
    device_sn?: string | null;
    device_id?: string | null;
    id?: string | null;
    reference_id?: string | null;
    trans_message?: string | null;
    type?: string | null;
    card_info?: {
      card_number_first_six?: string | null;
      card_number_last_four?: string | null;
      card_type?: string | null;
      cardholder_name?: string | null;
      expiration_date?: string | null;
    } | null;
  } | null>;
  signature?: { base_uri?: string | null } | null;
  transaction_discount?: { value?: number | null } | null;
};

export type BambooRedeemTransactionMutationVariables = Exact<{
  input_obj: Bamboo_Redemption_Transaction_Input;
}>;

export type BambooRedeemTransactionMutation = {
  bamboo_redemption_transaction: { id: string };
};

export type BambooSendReceiptEmailMutationVariables = Exact<{
  input_obj: Bamboo_Send_Receipt_Email_Input;
}>;

export type BambooSendReceiptEmailMutation = {
  bamboo_send_receipt_email: string;
};

export type BambooSendReceiptMessageMutationVariables = Exact<{
  input_obj: Bamboo_Sms_Send_Receipt_Input;
}>;

export type BambooSendReceiptMessageMutation = {
  bamboo_sms_send_receipt: string;
};

export type CheckGiftCardQueryVariables = Exact<{
  where?: InputMaybe<Gift_Card_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CheckGiftCardQuery = {
  gift_card: Array<{
    id: string;
    current_balance: any;
    status: string;
    transactions: Array<{
      type: string;
      date: string;
      balance_change: any;
      balance_before: any;
      order_id?: string | null;
      dts_order_id?: number | null;
    }>;
  }>;
};

export type GetTransactionDetailQueryVariables = Exact<{
  input_obj: Get_Transaction_Detail_Input;
}>;

export type GetTransactionDetailQuery = {
  get_transaction_detail: {
    balance_after?: number | null;
    balance_before?: number | null;
    balance_change?: number | null;
    code?: string | null;
    date?: string | null;
    id?: string | null;
    price?: number | null;
    type?: string | null;
    whmcs_id?: number | null;
    company?: {
      name?: string | null;
      address1?: string | null;
      address2?: string | null;
      business_phone?: string | null;
    } | null;
    gift_card?: {
      code?: string | null;
      pos_gift_card?: { code?: string | null; id?: string | null } | null;
    } | null;
    payment_methods: Array<{
      action?: string | null;
      auth_code?: string | null;
      device_sn?: string | null;
      device_id?: string | null;
      id?: string | null;
      reference_id?: string | null;
      trans_message?: string | null;
      type?: string | null;
      card_info?: {
        card_number_first_six?: string | null;
        card_number_last_four?: string | null;
        card_type?: string | null;
        cardholder_name?: string | null;
        expiration_date?: string | null;
      } | null;
    } | null>;
    signature?: { base_uri?: string | null } | null;
    transaction_discount?: { value?: number | null } | null;
  };
};

export type BambooTopUpTransactionMutationVariables = Exact<{
  input_obj: Bamboo_Top_Up_Transaction_Input;
}>;

export type BambooTopUpTransactionMutation = {
  bamboo_top_up_transaction: {
    gift_card_id: string;
    id: string;
    card_type?: string | null;
  };
};

export const BambooUserGetInfoFragmentDoc = `
    fragment BambooUserGetInfo on graphql_bamboo_user {
  whmcs_id
  time_zone
}
    `;
export const GiftCardTransactionFragmentDoc = `
    fragment GiftCardTransaction on graphql_gift_card_check_code_transaction {
  dts_order_id
  balance_after
  balance_before
  balance_change
  type
  date
}
    `;
export const GiftCardCheckCodeFragmentDoc = `
    fragment GiftCardCheckCode on graphql_gift_card_check_code {
  company_name
  whmcs_id
  created_at
  current_balance
  initial_balance
  amount
  price
  transactions {
    ...GiftCardTransaction
  }
}
    `;
export const GiftCardTransactionsFragmentDoc = `
    fragment GiftCardTransactions on transaction {
  id
  code
  price
  type
  date
  balance_change
  balance_after
  balance_before
  whmcs_id
  signature {
    base_uri
    name
  }
  gift_card {
    code
    customer_company {
      name
      customer {
        phone_number
      }
    }
    pos_gift_card {
      code
      id
    }
  }
  transaction_discount {
    value
  }
  payment_methods {
    type
    id
    action
    auth_code
    device_id
    device_sn
    trans_message
    reference_id
    card_info {
      card_number_first_six
      card_number_last_four
      cardholder_name
      card_type
      expiration_date
    }
  }
}
    `;
export const GiftCardInformationFragmentDoc = `
    fragment GiftCardInformation on gift_card {
  id
  current_balance
  status
  transactions {
    type
    date
    balance_change
    balance_before
    order_id
    dts_order_id
  }
}
    `;
export const TransactionDetailFragmentDoc = `
    fragment TransactionDetail on graphql_get_transaction_detail {
  balance_after
  balance_before
  balance_change
  code
  date
  company {
    name
    address1
    address2
    business_phone
  }
  gift_card {
    code
    pos_gift_card {
      code
      id
    }
  }
  id
  payment_methods {
    action
    auth_code
    device_sn
    card_info {
      card_number_first_six
      card_number_last_four
      card_type
      cardholder_name
      expiration_date
    }
    device_id
    id
    reference_id
    trans_message
    type
  }
  price
  signature {
    base_uri
  }
  transaction_discount {
    value
  }
  type
  whmcs_id
}
    `;
export const BambooUserGetInfoDocument = `
    query BambooUserGetInfo {
  bamboo_user_get_info {
    ...BambooUserGetInfo
  }
}
    ${BambooUserGetInfoFragmentDoc}`;

export const useBambooUserGetInfoQuery = <
  TData = BambooUserGetInfoQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables?: BambooUserGetInfoQueryVariables,
  options?: Omit<
    UseQueryOptions<BambooUserGetInfoQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      BambooUserGetInfoQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useQuery<BambooUserGetInfoQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['BambooUserGetInfo']
        : ['BambooUserGetInfo', variables],
    queryFn: fetcher<BambooUserGetInfoQuery, BambooUserGetInfoQueryVariables>(
      BambooUserGetInfoDocument,
    ).bind(null, variables),
    ...options,
  });
};

useBambooUserGetInfoQuery.getKey = (
  variables?: BambooUserGetInfoQueryVariables,
) =>
  variables === undefined
    ? ['BambooUserGetInfo']
    : ['BambooUserGetInfo', variables];

export const useSuspenseBambooUserGetInfoQuery = <
  TData = BambooUserGetInfoQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables?: BambooUserGetInfoQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BambooUserGetInfoQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseQueryOptions<
      BambooUserGetInfoQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useSuspenseQuery<BambooUserGetInfoQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['BambooUserGetInfoSuspense']
        : ['BambooUserGetInfoSuspense', variables],
    queryFn: fetcher<BambooUserGetInfoQuery, BambooUserGetInfoQueryVariables>(
      BambooUserGetInfoDocument,
    ).bind(null, variables),
    ...options,
  });
};

useSuspenseBambooUserGetInfoQuery.getKey = (
  variables?: BambooUserGetInfoQueryVariables,
) =>
  variables === undefined
    ? ['BambooUserGetInfoSuspense']
    : ['BambooUserGetInfoSuspense', variables];

export const useInfiniteBambooUserGetInfoQuery = <
  TData = InfiniteData<BambooUserGetInfoQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: BambooUserGetInfoQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BambooUserGetInfoQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseInfiniteQueryOptions<
      BambooUserGetInfoQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    BambooUserGetInfoQuery,
    BambooUserGetInfoQueryVariables
  >(BambooUserGetInfoDocument);
  return useInfiniteQuery<BambooUserGetInfoQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          optionsQueryKey ?? variables === undefined
            ? ['BambooUserGetInfo.infinite']
            : ['BambooUserGetInfo.infinite', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteBambooUserGetInfoQuery.getKey = (
  variables?: BambooUserGetInfoQueryVariables,
) =>
  variables === undefined
    ? ['BambooUserGetInfo.infinite']
    : ['BambooUserGetInfo.infinite', variables];

export const useSuspenseInfiniteBambooUserGetInfoQuery = <
  TData = InfiniteData<BambooUserGetInfoQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: BambooUserGetInfoQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BambooUserGetInfoQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BambooUserGetInfoQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    BambooUserGetInfoQuery,
    BambooUserGetInfoQueryVariables
  >(BambooUserGetInfoDocument);
  return useSuspenseInfiniteQuery<BambooUserGetInfoQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          optionsQueryKey ?? variables === undefined
            ? ['BambooUserGetInfo.infiniteSuspense']
            : ['BambooUserGetInfo.infiniteSuspense', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useSuspenseInfiniteBambooUserGetInfoQuery.getKey = (
  variables?: BambooUserGetInfoQueryVariables,
) =>
  variables === undefined
    ? ['BambooUserGetInfo.infiniteSuspense']
    : ['BambooUserGetInfo.infiniteSuspense', variables];

export const GiftCardCheckCodeDocument = `
    query GiftCardCheckCode($input_obj: gift_card_check_code_input!) {
  gift_card_check_code(input_obj: $input_obj) {
    ...GiftCardCheckCode
  }
}
    ${GiftCardCheckCodeFragmentDoc}
${GiftCardTransactionFragmentDoc}`;

export const useGiftCardCheckCodeQuery = <
  TData = GiftCardCheckCodeQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GiftCardCheckCodeQueryVariables,
  options?: Omit<
    UseQueryOptions<GiftCardCheckCodeQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      GiftCardCheckCodeQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useQuery<GiftCardCheckCodeQuery, TError, TData>({
    queryKey: ['GiftCardCheckCode', variables],
    queryFn: fetcher<GiftCardCheckCodeQuery, GiftCardCheckCodeQueryVariables>(
      GiftCardCheckCodeDocument,
    ).bind(null, variables),
    ...options,
  });
};

useGiftCardCheckCodeQuery.getKey = (
  variables: GiftCardCheckCodeQueryVariables,
) => ['GiftCardCheckCode', variables];

export const useSuspenseGiftCardCheckCodeQuery = <
  TData = GiftCardCheckCodeQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GiftCardCheckCodeQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GiftCardCheckCodeQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseQueryOptions<
      GiftCardCheckCodeQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useSuspenseQuery<GiftCardCheckCodeQuery, TError, TData>({
    queryKey: ['GiftCardCheckCodeSuspense', variables],
    queryFn: fetcher<GiftCardCheckCodeQuery, GiftCardCheckCodeQueryVariables>(
      GiftCardCheckCodeDocument,
    ).bind(null, variables),
    ...options,
  });
};

useSuspenseGiftCardCheckCodeQuery.getKey = (
  variables: GiftCardCheckCodeQueryVariables,
) => ['GiftCardCheckCodeSuspense', variables];

export const useInfiniteGiftCardCheckCodeQuery = <
  TData = InfiniteData<GiftCardCheckCodeQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GiftCardCheckCodeQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GiftCardCheckCodeQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseInfiniteQueryOptions<
      GiftCardCheckCodeQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    GiftCardCheckCodeQuery,
    GiftCardCheckCodeQueryVariables
  >(GiftCardCheckCodeDocument);
  return useInfiniteQuery<GiftCardCheckCodeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['GiftCardCheckCode.infinite', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGiftCardCheckCodeQuery.getKey = (
  variables: GiftCardCheckCodeQueryVariables,
) => ['GiftCardCheckCode.infinite', variables];

export const useSuspenseInfiniteGiftCardCheckCodeQuery = <
  TData = InfiniteData<GiftCardCheckCodeQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GiftCardCheckCodeQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GiftCardCheckCodeQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GiftCardCheckCodeQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    GiftCardCheckCodeQuery,
    GiftCardCheckCodeQueryVariables
  >(GiftCardCheckCodeDocument);
  return useSuspenseInfiniteQuery<GiftCardCheckCodeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? [
          'GiftCardCheckCode.infiniteSuspense',
          variables,
        ],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useSuspenseInfiniteGiftCardCheckCodeQuery.getKey = (
  variables: GiftCardCheckCodeQueryVariables,
) => ['GiftCardCheckCode.infiniteSuspense', variables];

export const CrmCompanyDocument = `
    query CrmCompany($input_obj: crm_company_input!) {
  crm_company(input_obj: $input_obj) {
    name
    address1
    business_phone
    time_zone
  }
}
    `;

export const useCrmCompanyQuery = <
  TData = CrmCompanyQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: CrmCompanyQueryVariables,
  options?: Omit<
    UseQueryOptions<CrmCompanyQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<CrmCompanyQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<CrmCompanyQuery, TError, TData>({
    queryKey: ['CrmCompany', variables],
    queryFn: fetcher<CrmCompanyQuery, CrmCompanyQueryVariables>(
      CrmCompanyDocument,
    ).bind(null, variables),
    ...options,
  });
};

useCrmCompanyQuery.getKey = (variables: CrmCompanyQueryVariables) => [
  'CrmCompany',
  variables,
];

export const useSuspenseCrmCompanyQuery = <
  TData = CrmCompanyQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: CrmCompanyQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CrmCompanyQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseQueryOptions<
      CrmCompanyQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useSuspenseQuery<CrmCompanyQuery, TError, TData>({
    queryKey: ['CrmCompanySuspense', variables],
    queryFn: fetcher<CrmCompanyQuery, CrmCompanyQueryVariables>(
      CrmCompanyDocument,
    ).bind(null, variables),
    ...options,
  });
};

useSuspenseCrmCompanyQuery.getKey = (variables: CrmCompanyQueryVariables) => [
  'CrmCompanySuspense',
  variables,
];

export const useInfiniteCrmCompanyQuery = <
  TData = InfiniteData<CrmCompanyQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: CrmCompanyQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CrmCompanyQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseInfiniteQueryOptions<
      CrmCompanyQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<CrmCompanyQuery, CrmCompanyQueryVariables>(
    CrmCompanyDocument,
  );
  return useInfiniteQuery<CrmCompanyQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['CrmCompany.infinite', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteCrmCompanyQuery.getKey = (variables: CrmCompanyQueryVariables) => [
  'CrmCompany.infinite',
  variables,
];

export const useSuspenseInfiniteCrmCompanyQuery = <
  TData = InfiniteData<CrmCompanyQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: CrmCompanyQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CrmCompanyQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CrmCompanyQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<CrmCompanyQuery, CrmCompanyQueryVariables>(
    CrmCompanyDocument,
  );
  return useSuspenseInfiniteQuery<CrmCompanyQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['CrmCompany.infiniteSuspense', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useSuspenseInfiniteCrmCompanyQuery.getKey = (
  variables: CrmCompanyQueryVariables,
) => ['CrmCompany.infiniteSuspense', variables];

export const GiftCardTransactionListDocument = `
    query GiftCardTransactionList($where: transaction_bool_exp, $offset: Int, $limit: Int, $orderBy: [transaction_order_by!]) {
  transaction(where: $where, offset: $offset, limit: $limit, order_by: $orderBy) {
    ...GiftCardTransactions
  }
}
    ${GiftCardTransactionsFragmentDoc}`;

export const useGiftCardTransactionListQuery = <
  TData = GiftCardTransactionListQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables?: GiftCardTransactionListQueryVariables,
  options?: Omit<
    UseQueryOptions<GiftCardTransactionListQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      GiftCardTransactionListQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useQuery<GiftCardTransactionListQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['GiftCardTransactionList']
        : ['GiftCardTransactionList', variables],
    queryFn: fetcher<
      GiftCardTransactionListQuery,
      GiftCardTransactionListQueryVariables
    >(GiftCardTransactionListDocument).bind(null, variables),
    ...options,
  });
};

useGiftCardTransactionListQuery.getKey = (
  variables?: GiftCardTransactionListQueryVariables,
) =>
  variables === undefined
    ? ['GiftCardTransactionList']
    : ['GiftCardTransactionList', variables];

export const useSuspenseGiftCardTransactionListQuery = <
  TData = GiftCardTransactionListQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables?: GiftCardTransactionListQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GiftCardTransactionListQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseQueryOptions<
      GiftCardTransactionListQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useSuspenseQuery<GiftCardTransactionListQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['GiftCardTransactionListSuspense']
        : ['GiftCardTransactionListSuspense', variables],
    queryFn: fetcher<
      GiftCardTransactionListQuery,
      GiftCardTransactionListQueryVariables
    >(GiftCardTransactionListDocument).bind(null, variables),
    ...options,
  });
};

useSuspenseGiftCardTransactionListQuery.getKey = (
  variables?: GiftCardTransactionListQueryVariables,
) =>
  variables === undefined
    ? ['GiftCardTransactionListSuspense']
    : ['GiftCardTransactionListSuspense', variables];

export const useInfiniteGiftCardTransactionListQuery = <
  TData = InfiniteData<GiftCardTransactionListQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GiftCardTransactionListQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GiftCardTransactionListQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseInfiniteQueryOptions<
      GiftCardTransactionListQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    GiftCardTransactionListQuery,
    GiftCardTransactionListQueryVariables
  >(GiftCardTransactionListDocument);
  return useInfiniteQuery<GiftCardTransactionListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          optionsQueryKey ?? variables === undefined
            ? ['GiftCardTransactionList.infinite']
            : ['GiftCardTransactionList.infinite', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGiftCardTransactionListQuery.getKey = (
  variables?: GiftCardTransactionListQueryVariables,
) =>
  variables === undefined
    ? ['GiftCardTransactionList.infinite']
    : ['GiftCardTransactionList.infinite', variables];

export const useSuspenseInfiniteGiftCardTransactionListQuery = <
  TData = InfiniteData<GiftCardTransactionListQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GiftCardTransactionListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<
      GiftCardTransactionListQuery,
      TError,
      TData
    >,
    'queryKey'
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GiftCardTransactionListQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    GiftCardTransactionListQuery,
    GiftCardTransactionListQueryVariables
  >(GiftCardTransactionListDocument);
  return useSuspenseInfiniteQuery<GiftCardTransactionListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          optionsQueryKey ?? variables === undefined
            ? ['GiftCardTransactionList.infiniteSuspense']
            : ['GiftCardTransactionList.infiniteSuspense', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useSuspenseInfiniteGiftCardTransactionListQuery.getKey = (
  variables?: GiftCardTransactionListQueryVariables,
) =>
  variables === undefined
    ? ['GiftCardTransactionList.infiniteSuspense']
    : ['GiftCardTransactionList.infiniteSuspense', variables];

export const GiftCardTransactionByPkDocument = `
    query GiftCardTransactionByPK($id: uuid!) {
  transaction_by_pk(id: $id) {
    ...GiftCardTransactions
  }
}
    ${GiftCardTransactionsFragmentDoc}`;

export const useGiftCardTransactionByPkQuery = <
  TData = GiftCardTransactionByPkQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GiftCardTransactionByPkQueryVariables,
  options?: Omit<
    UseQueryOptions<GiftCardTransactionByPkQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      GiftCardTransactionByPkQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useQuery<GiftCardTransactionByPkQuery, TError, TData>({
    queryKey: ['GiftCardTransactionByPK', variables],
    queryFn: fetcher<
      GiftCardTransactionByPkQuery,
      GiftCardTransactionByPkQueryVariables
    >(GiftCardTransactionByPkDocument).bind(null, variables),
    ...options,
  });
};

useGiftCardTransactionByPkQuery.getKey = (
  variables: GiftCardTransactionByPkQueryVariables,
) => ['GiftCardTransactionByPK', variables];

export const useSuspenseGiftCardTransactionByPkQuery = <
  TData = GiftCardTransactionByPkQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GiftCardTransactionByPkQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GiftCardTransactionByPkQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseQueryOptions<
      GiftCardTransactionByPkQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useSuspenseQuery<GiftCardTransactionByPkQuery, TError, TData>({
    queryKey: ['GiftCardTransactionByPKSuspense', variables],
    queryFn: fetcher<
      GiftCardTransactionByPkQuery,
      GiftCardTransactionByPkQueryVariables
    >(GiftCardTransactionByPkDocument).bind(null, variables),
    ...options,
  });
};

useSuspenseGiftCardTransactionByPkQuery.getKey = (
  variables: GiftCardTransactionByPkQueryVariables,
) => ['GiftCardTransactionByPKSuspense', variables];

export const useInfiniteGiftCardTransactionByPkQuery = <
  TData = InfiniteData<GiftCardTransactionByPkQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GiftCardTransactionByPkQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GiftCardTransactionByPkQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseInfiniteQueryOptions<
      GiftCardTransactionByPkQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    GiftCardTransactionByPkQuery,
    GiftCardTransactionByPkQueryVariables
  >(GiftCardTransactionByPkDocument);
  return useInfiniteQuery<GiftCardTransactionByPkQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? [
          'GiftCardTransactionByPK.infinite',
          variables,
        ],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGiftCardTransactionByPkQuery.getKey = (
  variables: GiftCardTransactionByPkQueryVariables,
) => ['GiftCardTransactionByPK.infinite', variables];

export const useSuspenseInfiniteGiftCardTransactionByPkQuery = <
  TData = InfiniteData<GiftCardTransactionByPkQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GiftCardTransactionByPkQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<
      GiftCardTransactionByPkQuery,
      TError,
      TData
    >,
    'queryKey'
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GiftCardTransactionByPkQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    GiftCardTransactionByPkQuery,
    GiftCardTransactionByPkQueryVariables
  >(GiftCardTransactionByPkDocument);
  return useSuspenseInfiniteQuery<GiftCardTransactionByPkQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? [
          'GiftCardTransactionByPK.infiniteSuspense',
          variables,
        ],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useSuspenseInfiniteGiftCardTransactionByPkQuery.getKey = (
  variables: GiftCardTransactionByPkQueryVariables,
) => ['GiftCardTransactionByPK.infiniteSuspense', variables];

export const TotalGiftCardSoldDocument = `
    query TotalGiftCardSold($where: gift_card_bool_exp) {
  gift_card_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export const useTotalGiftCardSoldQuery = <
  TData = TotalGiftCardSoldQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables?: TotalGiftCardSoldQueryVariables,
  options?: Omit<
    UseQueryOptions<TotalGiftCardSoldQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      TotalGiftCardSoldQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useQuery<TotalGiftCardSoldQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['TotalGiftCardSold']
        : ['TotalGiftCardSold', variables],
    queryFn: fetcher<TotalGiftCardSoldQuery, TotalGiftCardSoldQueryVariables>(
      TotalGiftCardSoldDocument,
    ).bind(null, variables),
    ...options,
  });
};

useTotalGiftCardSoldQuery.getKey = (
  variables?: TotalGiftCardSoldQueryVariables,
) =>
  variables === undefined
    ? ['TotalGiftCardSold']
    : ['TotalGiftCardSold', variables];

export const useSuspenseTotalGiftCardSoldQuery = <
  TData = TotalGiftCardSoldQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables?: TotalGiftCardSoldQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<TotalGiftCardSoldQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseQueryOptions<
      TotalGiftCardSoldQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useSuspenseQuery<TotalGiftCardSoldQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['TotalGiftCardSoldSuspense']
        : ['TotalGiftCardSoldSuspense', variables],
    queryFn: fetcher<TotalGiftCardSoldQuery, TotalGiftCardSoldQueryVariables>(
      TotalGiftCardSoldDocument,
    ).bind(null, variables),
    ...options,
  });
};

useSuspenseTotalGiftCardSoldQuery.getKey = (
  variables?: TotalGiftCardSoldQueryVariables,
) =>
  variables === undefined
    ? ['TotalGiftCardSoldSuspense']
    : ['TotalGiftCardSoldSuspense', variables];

export const useInfiniteTotalGiftCardSoldQuery = <
  TData = InfiniteData<TotalGiftCardSoldQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: TotalGiftCardSoldQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<TotalGiftCardSoldQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseInfiniteQueryOptions<
      TotalGiftCardSoldQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    TotalGiftCardSoldQuery,
    TotalGiftCardSoldQueryVariables
  >(TotalGiftCardSoldDocument);
  return useInfiniteQuery<TotalGiftCardSoldQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          optionsQueryKey ?? variables === undefined
            ? ['TotalGiftCardSold.infinite']
            : ['TotalGiftCardSold.infinite', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteTotalGiftCardSoldQuery.getKey = (
  variables?: TotalGiftCardSoldQueryVariables,
) =>
  variables === undefined
    ? ['TotalGiftCardSold.infinite']
    : ['TotalGiftCardSold.infinite', variables];

export const useSuspenseInfiniteTotalGiftCardSoldQuery = <
  TData = InfiniteData<TotalGiftCardSoldQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: TotalGiftCardSoldQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<TotalGiftCardSoldQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      TotalGiftCardSoldQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    TotalGiftCardSoldQuery,
    TotalGiftCardSoldQueryVariables
  >(TotalGiftCardSoldDocument);
  return useSuspenseInfiniteQuery<TotalGiftCardSoldQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          optionsQueryKey ?? variables === undefined
            ? ['TotalGiftCardSold.infiniteSuspense']
            : ['TotalGiftCardSold.infiniteSuspense', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useSuspenseInfiniteTotalGiftCardSoldQuery.getKey = (
  variables?: TotalGiftCardSoldQueryVariables,
) =>
  variables === undefined
    ? ['TotalGiftCardSold.infiniteSuspense']
    : ['TotalGiftCardSold.infiniteSuspense', variables];

export const TotalGiftCardDocument = `
    query TotalGiftCard($where: transaction_bool_exp) {
  transaction_aggregate(where: $where) {
    aggregate {
      sum {
        balance_change
      }
    }
  }
}
    `;

export const useTotalGiftCardQuery = <
  TData = TotalGiftCardQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables?: TotalGiftCardQueryVariables,
  options?: Omit<
    UseQueryOptions<TotalGiftCardQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<TotalGiftCardQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<TotalGiftCardQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['TotalGiftCard']
        : ['TotalGiftCard', variables],
    queryFn: fetcher<TotalGiftCardQuery, TotalGiftCardQueryVariables>(
      TotalGiftCardDocument,
    ).bind(null, variables),
    ...options,
  });
};

useTotalGiftCardQuery.getKey = (variables?: TotalGiftCardQueryVariables) =>
  variables === undefined ? ['TotalGiftCard'] : ['TotalGiftCard', variables];

export const useSuspenseTotalGiftCardQuery = <
  TData = TotalGiftCardQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables?: TotalGiftCardQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<TotalGiftCardQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseQueryOptions<
      TotalGiftCardQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useSuspenseQuery<TotalGiftCardQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['TotalGiftCardSuspense']
        : ['TotalGiftCardSuspense', variables],
    queryFn: fetcher<TotalGiftCardQuery, TotalGiftCardQueryVariables>(
      TotalGiftCardDocument,
    ).bind(null, variables),
    ...options,
  });
};

useSuspenseTotalGiftCardQuery.getKey = (
  variables?: TotalGiftCardQueryVariables,
) =>
  variables === undefined
    ? ['TotalGiftCardSuspense']
    : ['TotalGiftCardSuspense', variables];

export const useInfiniteTotalGiftCardQuery = <
  TData = InfiniteData<TotalGiftCardQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: TotalGiftCardQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<TotalGiftCardQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseInfiniteQueryOptions<
      TotalGiftCardQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<TotalGiftCardQuery, TotalGiftCardQueryVariables>(
    TotalGiftCardDocument,
  );
  return useInfiniteQuery<TotalGiftCardQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          optionsQueryKey ?? variables === undefined
            ? ['TotalGiftCard.infinite']
            : ['TotalGiftCard.infinite', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteTotalGiftCardQuery.getKey = (
  variables?: TotalGiftCardQueryVariables,
) =>
  variables === undefined
    ? ['TotalGiftCard.infinite']
    : ['TotalGiftCard.infinite', variables];

export const useSuspenseInfiniteTotalGiftCardQuery = <
  TData = InfiniteData<TotalGiftCardQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: TotalGiftCardQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<TotalGiftCardQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      TotalGiftCardQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<TotalGiftCardQuery, TotalGiftCardQueryVariables>(
    TotalGiftCardDocument,
  );
  return useSuspenseInfiniteQuery<TotalGiftCardQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          optionsQueryKey ?? variables === undefined
            ? ['TotalGiftCard.infiniteSuspense']
            : ['TotalGiftCard.infiniteSuspense', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useSuspenseInfiniteTotalGiftCardQuery.getKey = (
  variables?: TotalGiftCardQueryVariables,
) =>
  variables === undefined
    ? ['TotalGiftCard.infiniteSuspense']
    : ['TotalGiftCard.infiniteSuspense', variables];

export const BambooRedeemTransactionDocument = `
    mutation BambooRedeemTransaction($input_obj: bamboo_redemption_transaction_input!) {
  bamboo_redemption_transaction(input_obj: $input_obj) {
    id
  }
}
    `;

export const useBambooRedeemTransactionMutation = <
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    BambooRedeemTransactionMutation,
    TError,
    BambooRedeemTransactionMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    BambooRedeemTransactionMutation,
    TError,
    BambooRedeemTransactionMutationVariables,
    TContext
  >({
    mutationKey: ['BambooRedeemTransaction'],
    mutationFn: fetcher<
      BambooRedeemTransactionMutation,
      BambooRedeemTransactionMutationVariables
    >(BambooRedeemTransactionDocument),
    ...options,
  });
};

export const BambooSendReceiptEmailDocument = `
    mutation BambooSendReceiptEmail($input_obj: bamboo_send_receipt_email_input!) {
  bamboo_send_receipt_email(input_obj: $input_obj)
}
    `;

export const useBambooSendReceiptEmailMutation = <
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    BambooSendReceiptEmailMutation,
    TError,
    BambooSendReceiptEmailMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    BambooSendReceiptEmailMutation,
    TError,
    BambooSendReceiptEmailMutationVariables,
    TContext
  >({
    mutationKey: ['BambooSendReceiptEmail'],
    mutationFn: fetcher<
      BambooSendReceiptEmailMutation,
      BambooSendReceiptEmailMutationVariables
    >(BambooSendReceiptEmailDocument),
    ...options,
  });
};

export const BambooSendReceiptMessageDocument = `
    mutation BambooSendReceiptMessage($input_obj: bamboo_sms_send_receipt_input!) {
  bamboo_sms_send_receipt(input_obj: $input_obj)
}
    `;

export const useBambooSendReceiptMessageMutation = <
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    BambooSendReceiptMessageMutation,
    TError,
    BambooSendReceiptMessageMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    BambooSendReceiptMessageMutation,
    TError,
    BambooSendReceiptMessageMutationVariables,
    TContext
  >({
    mutationKey: ['BambooSendReceiptMessage'],
    mutationFn: fetcher<
      BambooSendReceiptMessageMutation,
      BambooSendReceiptMessageMutationVariables
    >(BambooSendReceiptMessageDocument),
    ...options,
  });
};

export const CheckGiftCardDocument = `
    query CheckGiftCard($where: gift_card_bool_exp, $limit: Int, $offset: Int) {
  gift_card(where: $where, limit: $limit, offset: $offset) {
    ...GiftCardInformation
  }
}
    ${GiftCardInformationFragmentDoc}`;

export const useCheckGiftCardQuery = <
  TData = CheckGiftCardQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables?: CheckGiftCardQueryVariables,
  options?: Omit<
    UseQueryOptions<CheckGiftCardQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<CheckGiftCardQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<CheckGiftCardQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['CheckGiftCard']
        : ['CheckGiftCard', variables],
    queryFn: fetcher<CheckGiftCardQuery, CheckGiftCardQueryVariables>(
      CheckGiftCardDocument,
    ).bind(null, variables),
    ...options,
  });
};

useCheckGiftCardQuery.getKey = (variables?: CheckGiftCardQueryVariables) =>
  variables === undefined ? ['CheckGiftCard'] : ['CheckGiftCard', variables];

export const useSuspenseCheckGiftCardQuery = <
  TData = CheckGiftCardQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables?: CheckGiftCardQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CheckGiftCardQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseQueryOptions<
      CheckGiftCardQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useSuspenseQuery<CheckGiftCardQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['CheckGiftCardSuspense']
        : ['CheckGiftCardSuspense', variables],
    queryFn: fetcher<CheckGiftCardQuery, CheckGiftCardQueryVariables>(
      CheckGiftCardDocument,
    ).bind(null, variables),
    ...options,
  });
};

useSuspenseCheckGiftCardQuery.getKey = (
  variables?: CheckGiftCardQueryVariables,
) =>
  variables === undefined
    ? ['CheckGiftCardSuspense']
    : ['CheckGiftCardSuspense', variables];

export const useInfiniteCheckGiftCardQuery = <
  TData = InfiniteData<CheckGiftCardQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: CheckGiftCardQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CheckGiftCardQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseInfiniteQueryOptions<
      CheckGiftCardQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<CheckGiftCardQuery, CheckGiftCardQueryVariables>(
    CheckGiftCardDocument,
  );
  return useInfiniteQuery<CheckGiftCardQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          optionsQueryKey ?? variables === undefined
            ? ['CheckGiftCard.infinite']
            : ['CheckGiftCard.infinite', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteCheckGiftCardQuery.getKey = (
  variables?: CheckGiftCardQueryVariables,
) =>
  variables === undefined
    ? ['CheckGiftCard.infinite']
    : ['CheckGiftCard.infinite', variables];

export const useSuspenseInfiniteCheckGiftCardQuery = <
  TData = InfiniteData<CheckGiftCardQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: CheckGiftCardQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CheckGiftCardQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CheckGiftCardQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<CheckGiftCardQuery, CheckGiftCardQueryVariables>(
    CheckGiftCardDocument,
  );
  return useSuspenseInfiniteQuery<CheckGiftCardQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          optionsQueryKey ?? variables === undefined
            ? ['CheckGiftCard.infiniteSuspense']
            : ['CheckGiftCard.infiniteSuspense', variables],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useSuspenseInfiniteCheckGiftCardQuery.getKey = (
  variables?: CheckGiftCardQueryVariables,
) =>
  variables === undefined
    ? ['CheckGiftCard.infiniteSuspense']
    : ['CheckGiftCard.infiniteSuspense', variables];

export const GetTransactionDetailDocument = `
    query GetTransactionDetail($input_obj: get_transaction_detail_input!) {
  get_transaction_detail(input_obj: $input_obj) {
    ...TransactionDetail
  }
}
    ${TransactionDetailFragmentDoc}`;

export const useGetTransactionDetailQuery = <
  TData = GetTransactionDetailQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GetTransactionDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<GetTransactionDetailQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      GetTransactionDetailQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useQuery<GetTransactionDetailQuery, TError, TData>({
    queryKey: ['GetTransactionDetail', variables],
    queryFn: fetcher<
      GetTransactionDetailQuery,
      GetTransactionDetailQueryVariables
    >(GetTransactionDetailDocument).bind(null, variables),
    ...options,
  });
};

useGetTransactionDetailQuery.getKey = (
  variables: GetTransactionDetailQueryVariables,
) => ['GetTransactionDetail', variables];

export const useSuspenseGetTransactionDetailQuery = <
  TData = GetTransactionDetailQuery,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GetTransactionDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GetTransactionDetailQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseQueryOptions<
      GetTransactionDetailQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useSuspenseQuery<GetTransactionDetailQuery, TError, TData>({
    queryKey: ['GetTransactionDetailSuspense', variables],
    queryFn: fetcher<
      GetTransactionDetailQuery,
      GetTransactionDetailQueryVariables
    >(GetTransactionDetailDocument).bind(null, variables),
    ...options,
  });
};

useSuspenseGetTransactionDetailQuery.getKey = (
  variables: GetTransactionDetailQueryVariables,
) => ['GetTransactionDetailSuspense', variables];

export const useInfiniteGetTransactionDetailQuery = <
  TData = InfiniteData<GetTransactionDetailQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GetTransactionDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GetTransactionDetailQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseInfiniteQueryOptions<
      GetTransactionDetailQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    GetTransactionDetailQuery,
    GetTransactionDetailQueryVariables
  >(GetTransactionDetailDocument);
  return useInfiniteQuery<GetTransactionDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? [
          'GetTransactionDetail.infinite',
          variables,
        ],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTransactionDetailQuery.getKey = (
  variables: GetTransactionDetailQueryVariables,
) => ['GetTransactionDetail.infinite', variables];

export const useSuspenseInfiniteGetTransactionDetailQuery = <
  TData = InfiniteData<GetTransactionDetailQuery>,
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
>(
  variables: GetTransactionDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GetTransactionDetailQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GetTransactionDetailQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  const query = fetcher<
    GetTransactionDetailQuery,
    GetTransactionDetailQueryVariables
  >(GetTransactionDetailDocument);
  return useSuspenseInfiniteQuery<GetTransactionDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? [
          'GetTransactionDetail.infiniteSuspense',
          variables,
        ],
        queryFn: (metaData) =>
          query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useSuspenseInfiniteGetTransactionDetailQuery.getKey = (
  variables: GetTransactionDetailQueryVariables,
) => ['GetTransactionDetail.infiniteSuspense', variables];

export const BambooTopUpTransactionDocument = `
    mutation BambooTopUpTransaction($input_obj: bamboo_top_up_transaction_input!) {
  bamboo_top_up_transaction(input_obj: $input_obj) {
    gift_card_id
    id
    card_type
  }
}
    `;

export const useBambooTopUpTransactionMutation = <
  TError = InvalidInputError | InvalidCredentialsError | ClientError | Error,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    BambooTopUpTransactionMutation,
    TError,
    BambooTopUpTransactionMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    BambooTopUpTransactionMutation,
    TError,
    BambooTopUpTransactionMutationVariables,
    TContext
  >({
    mutationKey: ['BambooTopUpTransaction'],
    mutationFn: fetcher<
      BambooTopUpTransactionMutation,
      BambooTopUpTransactionMutationVariables
    >(BambooTopUpTransactionDocument),
    ...options,
  });
};
